import React, { useEffect, useRef, useState } from 'react';
import { Badge, Col, FormFeedback, FormGroup, Input, Label, Row, Spinner, Table, Button, ModalHeader, ModalBody, CustomInput, ModalFooter, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import moment from 'moment';
import { Box, Button as Btn, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Modal, InputLabel, MenuItem, Radio, RadioGroup, Rating, Select, TextField, TextareaAutosize, Typography } from '@mui/material';
import { Edit } from '@material-ui/icons';
import AddFilesNoForm from '../Template/Files/AddFilesNoForm';
import FormInputTooltip from '../Template/Tooltip/FormInputTooltip';
import AsyncSelect from '../Template/Input/AsyncSelect';
import { notifyError, notifySuccess } from '../../utils/notify';
import SearchableSelect from 'react-select'
import MaskedInput from '../Template/Input/MaskedInput';
import DatePicker from 'react-datepicker';
import { getReg, insert, notifyByEmail, selectValues, sendEmailToNotify, symmetricRound, update } from '../../utils/fc';
import { useSelector } from 'react-redux';
import oikosApi from '../../services/oikos';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import changePosition from '../../utils/array/changePosition';
import { v4 as uuidv4 } from 'uuid'
import currencyFormatter from '../../utils/currencyFormatter';
import AddFiles from '../Template/Files/AddFiles';
import qs from 'qs';
import ModalConfirmacao from '../Modals/ModalConfirmacao/ModalConfirmacao';
import powerAppsApi from '../../services/powerapps/index';
import { add } from 'lodash';
import MaterialReactTable from 'material-react-table';

const YES_OR_NOT = [
  {
    label: 'Não',
    value: '0',
  },
  {
    label: 'Sim',
    value: 1,
  },
]

const isValidDateValue = (value) => (
  value !== null
  && value !== undefined
  && value !== ''
  && moment(value).isValid()
)

const formatDateValue = (value, format, fallback = undefined) => (
  isValidDateValue(value) ? moment(value).format(format) : fallback
)

/** Remove null/'' em campos de data — o PHP do Oikos grava '' e o MySQL responde 400. */
const sanitizeOikosPayload = (data) => {
  const out = {}
  Object.entries(data || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    if (/(_dt|Dt|Data|data)/.test(key) && (value === 'Invalid date' || value === 'null')) return
    out[key] = value
  })
  return out
}

/** Item já persistido no original — não deve ser INSERT no aditivo. */
const isExistingCronogramaItem = (item) => {
  if (!item) return false
  if (item.origin === 'existing') return true
  if (item.origin === 'new') return false
  return false
}

/** Só itens novos entram como INSERT (aditivo ou contrato). */
const shouldInsertCronogramaItem = (item, idKey) => {
  if (!item) return false
  if (isExistingCronogramaItem(item)) return false
  if (item[idKey]) return false
  if (item.origin === 'new') return true
  return Boolean(item.tempId)
}

const formatApiError = (e) => {
  if (!e) return 'erro desconhecido'
  if (typeof e === 'string') return e
  if (e.message && typeof e.message === 'string' && e.message !== '[object Object]') return e.message
  const data = e.data
  if (typeof data === 'string' && data.trim()) {
    const dateCol = data.match(/Incorrect date value: '' for column [`'][^`']*[`']\.([a-zA-Z0-9_]+)/)
    if (dateCol) return `Data inválida no campo ${dateCol[1]} (valor vazio).`
    const sqlMsg = data.match(/string\(\d+\)\s+"([^"]+)"/)
    if (sqlMsg) return sqlMsg[1]
    return data.replace(/\s+/g, ' ').slice(0, 240)
  }
  if (data?.detail) return data.detail
  if (data?.message) return data.message
  if (e.problem && e.status) return `${e.problem} (HTTP ${e.status})`
  if (e.problem) return e.problem
  try { return JSON.stringify(data || e).slice(0, 240) } catch (_) { return 'erro desconhecido' }
}

const toDateOrNull = (value) => (
  isValidDateValue(value) ? moment(value).toDate() : null
)

const columns = [
  {
    accessorKey: 'contratoProd_desc',
    header: 'Descrição',
    size: 100,
  },
  {
    accessorKey: 'contratoProd_dtPrev',
    header: 'Data Prevista',
    size: 100,
    accessorFn: (row) => {
      return formatDateValue(row.contratoProd_dtPrev, 'YYYY-MM-DD')
    }
  }
]

async function saveContrato(contratoFile, contratoData) {
  // Cria um registro na tabela de documentos para cada arquivo
  const documentBody = {
    action: 'insert',
    table: 'documento',
    data: {
      tpDocumento_id: 20,
      documento_desc: `Contrato ${contratoFile.arquivo.path}`,
      documento_iniVig: undefined,
      documento_fimVig: undefined,
      documento_dtEmissao: undefined,
      documento_prazo: undefined,
      documento_ref: undefined,
      privacidade_id: 2,
    },
  }
  const documentCreated = await oikosApi.post('/', documentBody)

  // Cria uma vinculação entre o documento (anexo) e o registro da minuta
  if (documentCreated.data[0].documento_id) {
    const vinculationBody = {
      action: 'insert',
      table: 'documentoVinc',
      data: {
        documento_id: documentCreated.data[0].documento_id,
        documentoVinc_tabRef: 'contrato',
        documentoVinc_tabId: contratoData.contrato_id,
      },
    }
    await oikosApi.post('/', vinculationBody)
  }

  // Faz upload do arquivo e registra na tabela 'arquivo'
  const formData = new FormData()
  formData.append('file', new Blob([contratoFile.arquivo], { type: contratoFile.arquivo.type }), contratoFile.arquivo.path)
  formData.append('table', 'arquivo')
  formData.append('action', 'upload_file')
  formData.append('arquivo_tabRef', 'documento')
  formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
  formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
  formData.append('arquivo_desc', contratoFile.arquivo.path)
  const fileUploadRes = await oikosApi.post('/', formData)

}

async function savePropostaComercial(propostaComercialFile, contratoData) {
  // Cria um registro na tabela de documentos para cada arquivo
  const documentBody = {
    action: 'insert',
    table: 'documento',
    data: {
      tpDocumento_id: 21,
      documento_desc: `Proposta Comercial ${propostaComercialFile.arquivo.path}`,
      documento_iniVig: undefined,
      documento_fimVig: undefined,
      documento_dtEmissao: undefined,
      documento_prazo: undefined,
      documento_ref: undefined,
      privacidade_id: 2,
    },
  }
  const documentCreated = await oikosApi.post('/', documentBody)

  // Cria uma vinculação entre o documento (anexo) e o registro da minuta
  if (documentCreated.data[0].documento_id) {
    const vinculationBody = {
      action: 'insert',
      table: 'documentoVinc',
      data: {
        documento_id: documentCreated.data[0].documento_id,
        documentoVinc_tabRef: 'contrato',
        documentoVinc_tabId: contratoData.contrato_id,
      },
    }
    await oikosApi.post('/', vinculationBody)
  }

  // Faz upload do arquivo e registra na tabela 'arquivo'
  const formData = new FormData()
  formData.append('file', new Blob([propostaComercialFile.arquivo], { type: propostaComercialFile.arquivo.type }), propostaComercialFile.arquivo.path)
  formData.append('table', 'arquivo')
  formData.append('action', 'upload_file')
  formData.append('arquivo_tabRef', 'documento')
  formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
  formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
  formData.append('arquivo_desc', propostaComercialFile.arquivo.path)
  const fileUploadRes = await oikosApi.post('/', formData)

}

async function saveTermoDeReferencia(termoDeReferenciaFile, contratoData) {
  // Cria um registro na tabela de documentos para cada arquivo
  const documentBody = {
    action: 'insert',
    table: 'documento',
    data: {
      tpDocumento_id: 22,
      documento_desc: `Termo de Referencia ${termoDeReferenciaFile.arquivo.path}`,
      documento_iniVig: undefined,
      documento_fimVig: undefined,
      documento_dtEmissao: undefined,
      documento_prazo: undefined,
      documento_ref: undefined,
      privacidade_id: 2,
    },
  }
  const documentCreated = await oikosApi.post('/', documentBody)

  // Cria uma vinculação entre o documento (anexo) e o registro da minuta
  if (documentCreated.data[0].documento_id) {
    const vinculationBody = {
      action: 'insert',
      table: 'documentoVinc',
      data: {
        documento_id: documentCreated.data[0].documento_id,
        documentoVinc_tabRef: 'contrato',
        documentoVinc_tabId: contratoData.contrato_id,
      },
    }
    await oikosApi.post('/', vinculationBody)
  }

  // Faz upload do arquivo e registra na tabela 'arquivo'
  const formData = new FormData()
  formData.append('file', new Blob([termoDeReferenciaFile.arquivo], { type: termoDeReferenciaFile.arquivo.type }), termoDeReferenciaFile.arquivo.path)
  formData.append('table', 'arquivo')
  formData.append('action', 'upload_file')
  formData.append('arquivo_tabRef', 'documento')
  formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
  formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
  formData.append('arquivo_desc', termoDeReferenciaFile.arquivo.path)
  const fileUploadRes = await oikosApi.post('/', formData)

}

async function saveAnexosGeral(files, contratoData) {

  if (files.find(item => item.tipo === 'contrato')) {

    await saveContrato(files.find(item => item.tipo === 'contrato'), contratoData)
  }
  if (files.find(item => item.tipo === 'proposta comercial')) {

    await savePropostaComercial(files.find(item => item.tipo === 'proposta comercial'), contratoData)
  }
  if (files.find(item => item.tipo === 'termo de referencia')) {

    await saveTermoDeReferencia(files.find(item => item.tipo === 'termo de referencia'), contratoData)
  }
  else {

  }
}

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const AddContract2 = (props) => {

  const [open, setOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [openAddProductModal, setOpenAddProductModal] = useState(false);
  const [openEditProductModal, setOpenEditProductModal] = useState(false);
  const [openEditPaymentModal, setOpenEditPaymentModal] = useState(false);
  const [openDeleteProductModal, setOpenDeleteProductModal] = useState(false);
  const [openModalCloseConfirmation, setOpenModalCloseConfirmation] = useState(false);
  const [openAddPaymentEventModal, setOpenAddPaymentEventModal] = useState(false);
  const [data, setData] = useState(props.data.data);
  const [products, setProducts] = useState(props.data.products);
  const [paymentEvents, setPaymentEvents] = useState(props.data.paymentEvents);
  const [editProductData, setEditProductData] = useState({});
  const [editPaymentData, setEditPaymentData] = useState({});
  const [addProductData, setAddProductData] = useState({});
  const [deleteProductData, setDeleteProductData] = useState({});
  const [addPaymentData, setAddPaymentData] = useState({});
  const [deletePaymentData, setDeletePaymentData] = useState({});
  const [isLoadingRow, setIsLoadingRow] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [addPfData, setAddPfData] = useState({});
  const [selContrato, setSelContrato] = useState([]);
  const [selContratoInst, setSelContratoInst] = useState([]);
  const [selContratoAlterTp, setSelContratoAlterTp] = useState([]);
  const [selContratante, setSelContratante] = useState([]);
  const [selContratada, setSelContratada] = useState([]);
  const [selAreaAtua, setSelAreaAtua] = useState([]);
  const [selMun, setSelMun] = useState([]);
  const [selIndReaj, setSelIndReaj] = useState([]);
  const [contratoFile, setContratoFile] = useState([]);
  const [linkContratoFile, setLinkContratoFile] = useState([]);
  const [propostaComercialFile, setPropostaComercialFile] = useState([]);
  const [linkPropostaComercialFile, setLinkPropostaComercialFile] = useState([]);
  const [termoDeReferenciaFile, setTermoDeReferenciaFile] = useState([]);
  const [linkTermoDeReferenciaFile, setLinkTermoDeReferenciaFile] = useState([]);
  const [valorGlobal, setValorGlobal] = useState(String(props.data.data.contrato_vlrGlobal))
  const [aliquotaISSQN, setAliquotaISSQN] = useState(String(props.data.data.contrato_aliqISS))
  const [addContractIsLoading, setAddContractIsLoading] = useState(false);
  const [openModalConfirmEPDelete, setOpenModalConfirmEPDelete] = useState(false)
  const [valorInput, setValorInput] = useState(String(addProductData.contratoEP_vlr));
  const [percentInput, setPercentInput] = useState(String((100 * addProductData.contratoEP_vlr / valorGlobal) || 0));
  const [produtosMedicaoComposta, setProdutosMedicaoComposta] = useState([])

  const comercial = useSelector(state => state.comercial);
  let { legalEntities } = comercial;

  const auth = useSelector(state => state.auth);
  const { user } = auth;

  legalEntities = legalEntities?.map(i => ({
    value: i.pj_id,
    label: i.pj_nomefanta,
  }))

  const getInstLabel = (id) => selContratoInst?.find(x => String(x.value) === String(id))?.label || '';
  const getAlterTpLabel = (id) => selContratoAlterTp?.find(x => String(x.value) === String(id))?.label || '';

  const checkVisible = (fieldName) => {
    if (!props.isAditivoMode) return true;
    
    const instLabel = String(getInstLabel(data.contratoInst_id)).toLowerCase().trim();
    const alterTpLabel = String(getAlterTpLabel(data.contratoAlterTp_id)).toLowerCase().trim();
    if (instLabel === 'rescisão' || instLabel === 'rescisao') {
      return fieldName === 'contrato_obs';
    }
    if (instLabel === 'apostilamento') {
      return ['valorGlobal', 'contrato_dtBaseReaj', 'contrato_indReaj_id', 'contrato_obs'].includes(fieldName);
    }
    if (instLabel === 'aditamento') {
      if (['reequilíbrio econômico-financeiro', 'reajuste de preço', 'supressão de preço', 'aditivo de valor'].includes(alterTpLabel)) return ['valorGlobal', 'contrato_obs'].includes(fieldName);
      if (['reajuste de prazo', 'aditivo de prazo', 'supressão de prazo'].includes(alterTpLabel)) return ['contrato_prazoVigencia', 'contrato_prazoExecucao', 'contrato_obs'].includes(fieldName);
      if (['reajuste de preço e prazo', 'aditivo de prazo e valor'].includes(alterTpLabel)) return ['contrato_prazoVigencia', 'contrato_prazoExecucao', 'valorGlobal', 'contrato_obs'].includes(fieldName);
      if (['aditivo de objeto'].includes(alterTpLabel)) return ['contrato_obs'].includes(fieldName);
    }
    return false;
  };

  const getOptionsMotivo = () => {
    if (!props.isAditivoMode) return selContratoAlterTp || [];
    const instLabel = String(getInstLabel(data.contratoInst_id)).toLowerCase().trim();
    if (instLabel === 'apostilamento') return selContratoAlterTp?.filter(opt => ['reajuste de preço', 'reajuste de prazo', 'reajuste de preço e prazo'].includes(String(opt.label).toLowerCase().trim())) || [];
    if (instLabel === 'aditamento') return selContratoAlterTp?.filter(opt => ['reequilíbrio econômico-financeiro', 'reajuste de preço', 'reajuste de prazo', 'reajuste de preço e prazo', 'aditivo de objeto', 'supressão de preço', 'supressão de prazo', 'aditivo de prazo', 'aditivo de valor', 'aditivo de prazo e valor'].includes(String(opt.label).toLowerCase().trim())) || [];
    if (instLabel === 'rescisão' || instLabel === 'rescisao') return [];
    return selContratoAlterTp?.filter(opt => ['aditivo de prazo', 'aditivo de valor', 'aditivo de prazo e valor', 'aditivo de objeto'].includes(String(opt.label).toLowerCase().trim())) || [];
  };

  async function getLinkContrato(contratoId) {
    if (!contratoId) return [];
    const docsVinculados = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabId: contratoId
      },
      fields: {
        '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 6 AND doc.documento_id = documentoVinc.documento_id))': 'linkDocumento',
      }
    })}`)

    const arrayDocumentosComLink = docsVinculados.data.filter((doc => doc.linkDocumento))

    if (arrayDocumentosComLink.length === 0) {
      return [];
    }

    const linksDocumentos = arrayDocumentosComLink.map(arquivo => arquivo.linkDocumento);

    return linksDocumentos;

  }

  async function getLinkTermoDeReferencia(contratoId) {
    if (!contratoId) return [];
    const docsVinculados = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabId: contratoId
      },
      fields: {
        '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 22 AND doc.documento_id = documentoVinc.documento_id))': 'linkDocumento',
      }
    })}`)

    const arrayDocumentosComLink = docsVinculados.data.filter((doc => doc.linkDocumento))

    if (arrayDocumentosComLink.length === 0) {
      return [];
    }

    const linksDocumentos = arrayDocumentosComLink.map(arquivo => arquivo.linkDocumento);

    return linksDocumentos;

  }

  async function getLinkPropostaComercial(contratoId) {
    if (!contratoId) return [];
    const docsVinculados = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabId: contratoId
      },
      fields: {
        '(SELECT arquivo.arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabId = (SELECT doc.documento_id FROM documento doc WHERE doc.tpDocumento_id = 21 AND doc.documento_id = documentoVinc.documento_id))': 'linkDocumento',
      }
    })}`)

    const arrayDocumentosComLink = docsVinculados.data.filter((doc => doc.linkDocumento))

    if (arrayDocumentosComLink.length === 0) {
      return [];
    }

    const linksDocumentos = arrayDocumentosComLink.map(arquivo => arquivo.linkDocumento);

    return linksDocumentos;

  }

  const handleClickOpen = async (targetInstLabel = null) => {
    setIsLoadingRow(true);

    // No modo aditivo não exige orçamento de proposta do próprio aditivo
    if (!props.isAditivoMode) {
      const checkProposta = await powerAppsApi.post('/',
        {
          contrato_id: data.contrato_id
        },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        }
      )

      if (!checkProposta) {
        notifyError("Não é possível cadastrar contrato sem orçamento da proposta. Cadastre o orçamento da proposta antes de cadastrar o contrato");
        setIsLoadingRow(false);
        return
      }
    }

    const originalContratoId = props.isAditivoMode
      ? (data.contrato_original || props.data?.data?.contrato_original)
      : (data.contrato_id || props.data?.data?.contrato_id);

    if (targetInstLabel && targetInstLabel.toLowerCase() === 'rescisão') {
      const _selContratoInst = await selectValues('contratoInst', 'contratoInst_id', 'contratoInst_desc', { contratoInst_ativo: 1 });
      const rescisaoInst = _selContratoInst.find(x => String(x.label).toLowerCase().trim() === 'rescisão' || String(x.label).toLowerCase().trim() === 'rescisao');
      if (rescisaoInst) {
        const resRescisao = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'contrato',
          data: {
            contrato_original: originalContratoId,
            contratoInst_id: rescisaoInst.value,
            contrato_ativo: 1
          }
        })}`);
        if (resRescisao.data && resRescisao.data.length > 0) {
          notifyError("Já existe uma rescisão cadastrada para este contrato.");
          setIsLoadingRow(false);
          return;
        }
      }
    }

    setOpen(true);

    await preloading(targetInstLabel);

    setIsLoadingRow(false);

  };

  const cloneCronogramaFromContrato = async (sourceContratoId) => {
    if (!sourceContratoId) {
      setProducts([])
      setPaymentEvents([])
      return
    }

    const [epsContrato, productsContrato] = await Promise.all([
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contratoEP',
        data: {
          contrato_id: sourceContratoId,
          contratoEP_ativo: 1,
        }
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contratoProd',
        data: {
          contrato_id: sourceContratoId,
          contratoProd_ativo: 1,
        },
      })}`),
    ])

    const sourceProducts = Array.isArray(productsContrato?.data) ? productsContrato.data : []
    const sourceEps = Array.isArray(epsContrato?.data) ? epsContrato.data : []

    const prodTempBySourceId = {}
    const epTempBySourceId = {}

    const clonedProducts = sourceProducts.map((product, index) => {
      const tempId = uuidv4()
      if (product.contratoProd_id) {
        prodTempBySourceId[product.contratoProd_id] = tempId
      }
      const prazoRaw = product.contratoProd_prazo
      const prazoNum = prazoRaw === null || prazoRaw === undefined || prazoRaw === ''
        ? ''
        : (Number(String(prazoRaw).replace(/[^\d.-]/g, '')) || prazoRaw)
      return {
        tempId,
        origin: 'existing',
        contratoProd_id: product.contratoProd_id || null,
        contratoEP_id: product.contratoEP_id || null,
        sourceContratoProd_id: product.contratoProd_id || null,
        sourceContratoEP_id: product.contratoEP_id || null,
        order: index + 1,
        contratoProd_desc: product.contratoProd_desc || '',
        contratoProd_prazo: prazoNum,
        contratoProd_dtPrev: formatDateValue(product.contratoProd_dtPrev, 'YYYY-MM-DD', null),
        hasPaymentEvent: Boolean(product.contratoEP_id),
      }
    })

    const clonedEps = sourceEps.map((ep, index) => {
      const tempId = uuidv4()
      if (ep.contratoEP_id) {
        epTempBySourceId[ep.contratoEP_id] = tempId
      }
      const prazoRaw = ep.contratoEP_prazo
      const prazoNum = prazoRaw === null || prazoRaw === undefined || prazoRaw === ''
        ? ''
        : (Number(String(prazoRaw).replace(/[^\d.-]/g, '')) || prazoRaw)

      let productId = null
      if (ep.contratoProd_id && prodTempBySourceId[ep.contratoProd_id]) {
        productId = prodTempBySourceId[ep.contratoProd_id]
      } else {
        const linkedProd = clonedProducts.find(p =>
          (p.contratoEP_id && p.contratoEP_id === ep.contratoEP_id)
          || (p.sourceContratoEP_id && p.sourceContratoEP_id === ep.contratoEP_id)
        )
        if (linkedProd) productId = linkedProd.tempId
      }

      const recTpId = typeof ep.recTp_id === 'object' && ep.recTp_id
        ? ep.recTp_id
        : (ep.recTp_id ? { recTp_id: ep.recTp_id } : { recTp_id: productId ? 1 : 6 })

      return {
        tempId,
        origin: 'existing',
        contratoEP_id: ep.contratoEP_id || null,
        contratoProd_id: ep.contratoProd_id || null,
        sourceContratoEP_id: ep.contratoEP_id || null,
        sourceContratoProd_id: ep.contratoProd_id || null,
        order: index + 1,
        contratoEP_desc: ep.contratoEP_desc || '',
        contratoEP_vlr: ep.contratoEP_vlr ?? '',
        contratoEP_prazo: prazoNum,
        contratoEP_dtPrev: formatDateValue(ep.contratoEP_dtPrev, 'YYYY-MM-DD', null),
        productId,
        recTp_id: recTpId,
      }
    })

    // Liga paymentId nos produtos quando houver EP correspondente
    const productsWithPayment = clonedProducts.map((product) => {
      const ep = clonedEps.find(e =>
        e.productId === product.tempId
        || (product.contratoEP_id && e.contratoEP_id === product.contratoEP_id)
        || (product.sourceContratoEP_id && e.sourceContratoEP_id === product.sourceContratoEP_id)
      )
      if (!ep) return product
      return {
        ...product,
        paymentId: ep.tempId,
        contratoEP_id: product.contratoEP_id || ep.contratoEP_id || null,
        hasPaymentEvent: true,
      }
    })

    setProducts(productsWithPayment)
    setPaymentEvents(clonedEps)
  }

  const preloading = async (targetInstLabel = null) => {
    const contratantes = await selectValues('pj', 'pj_id', 'pj_nomefanta', {});
    const contratadas = [contratantes[0], contratantes[1]];

    if (props.isAditivoMode) {
      const sourceId = data.contrato_original || props.data?.data?.contrato_original
      await cloneCronogramaFromContrato(sourceId)
    } else if (props.data.data.contrato_id) {
      const epsContrato = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contratoEP',
        data: {
          contrato_id: props.data.data.contrato_id,
          contratoEP_ativo: 1,
        }
      })}`);

      if (epsContrato.data.length > 0) {
        const epsContratoFromDataBase = epsContrato.data.map(ep => {
          if (ep.contratoProd_id) {
            return { ...ep, fromDataBase: 1, hasProduct: true }
          }
          return { ...ep, fromDataBase: 1 }
        })

        setPaymentEvents(epsContratoFromDataBase);
      }

      const productsContrato = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contratoProd',
        data: {
          contrato_id: props.data.data.contrato_id,
          contratoProd_ativo: 1,
        },
        fields: {
          '(SELECT contratoEP_id FROM contratoEP WHERE contratoProd.contratoProd_id = contratoEP.contratoProd_id LIMIT 1)': 'hasPaymentEvent'
        }
      })}`);

      if (productsContrato.data.length > 0) {
        const productsContratoFromDataBase = productsContrato.data.map(product => {
          return { ...product, fromDataBase: 1 }
        })
        setProducts(productsContratoFromDataBase);
      }
    }

    const selectContratos = await selectValues('contrato', 'contrato_id', 'contrato_num', {}, {
      '(SELECT pj_nomefanta FROM pj WHERE pj_id = (SELECT contrato_contratante FROM contrato as ct WHERE ct.contrato_id = contrato.contrato_id))': 'pj_nomefanta',
      '(SELECT proj_nome FROM proj WHERE proj.contrato_id = contrato.contrato_id AND proj_ativo = 1)': 'proj_nome',
      '(SELECT contrato_contratante FROM contrato as ct WHERE ct.contrato_id = contrato.contrato_id)': 'contrato_contratante',
      '(SELECT contrato_original FROM contrato as ct WHERE ct.contrato_id = contrato.contrato_id)': 'contrato_original'
    })
    const mappedSelectContratos = selectContratos.map((op) => { return { value: op.value, label: `${op.pj_nomefanta} - ${op.proj_nome}`, contrato_contratante: op.contrato_contratante, contrato_original: op.contrato_original } })
    setSelContrato(mappedSelectContratos);

    const _selContratoInst = await selectValues('contratoInst', 'contratoInst_id', 'contratoInst_desc');
    setSelContratoInst(_selContratoInst);

    if (targetInstLabel && typeof targetInstLabel === 'string') {
      const foundInst = _selContratoInst?.find(x => String(x.label).toLowerCase().trim() === targetInstLabel.toLowerCase().trim());
      if (foundInst) {
        setData(prev => ({ ...prev, contratoInst_id: foundInst.value, contratoAlterTp_id: null }));
      }
    }

    setSelContratoAlterTp(await selectValues('contratoAlterTp', 'contratoAlterTp_id', 'contratoAlterTp_desc'));
    setSelAreaAtua(await selectValues('areaAtua', 'areaAtua_id', 'areaAtua_area'));
    setSelContratante(contratantes);
    setSelContratada(contratadas);
    setSelMun(await selectValues('mun', 'mun_id', 'mun_nome'));
    setSelIndReaj(await selectValues('indReaj', 'indReaj_id', 'indReaj_sigla'));

    const linkSourceId = props.isAditivoMode
      ? (data.contrato_original || props.data?.data?.contrato_original)
      : props.data.data.contrato_id
    const linkContratoFileResultado = await getLinkContrato(linkSourceId);
    setLinkContratoFile(linkContratoFileResultado);
    const linkTermoDeReferenciaFileResultado = await getLinkTermoDeReferencia(linkSourceId);
    setLinkTermoDeReferenciaFile(linkTermoDeReferenciaFileResultado);
    const linkPropostaComercialFileResultado = await getLinkPropostaComercial(linkSourceId);
    setLinkPropostaComercialFile(linkPropostaComercialFileResultado);
  }

  const handleClose = () => {
    setOpen(false);
  };

  const checaEPeProdPrevForaDataVigencia = (dateVigencia) => {
    let check = false;

    const dateVigenciaMoment = new Date(dateVigencia).getTime()
    for (const pe of paymentEvents) {

      const dt_Prev = new Date(pe.contratoEP_dtPrev).getTime()


      if (dateVigenciaMoment < dt_Prev) {
        check = true;
      }
    }
    for (const p of products) {


      const dt_Prev = new Date(p.contratoProd_dtPrev).getTime()


      if (dateVigenciaMoment < dt_Prev) {
        check = true;
      }
    }
    return check;
  }

  const hasProductWithoutExpectedDate = () => false

  const hasPaymentEventWithoutExpectedDate = () => false

  const handleAddProductInline = () => {
    const productTempId = uuidv4()
    const desc = ''
    const normalizedDesc = desc.trim().toLowerCase()
    if (normalizedDesc && products.some(p => String(p.contratoProd_desc || '').trim().toLowerCase() === normalizedDesc)) {
      notifyError('Já existe um produto com essa descrição. Não é permitido duplicar.')
      return
    }
    setProducts([
      ...products,
      {
        tempId: productTempId,
        origin: 'new',
        order: products.length + 1,
        contratoProd_desc: '',
        contratoProd_prazo: '',
        contratoProd_dtPrev: null,
      },
    ])
  }

  const updateProductByTempId = (tempId, field, value) => {
    setProducts((prev) => prev.map((p) => {
      if (p.tempId !== tempId && String(p.contratoProd_id) !== String(tempId)) return p
      return { ...p, [field]: value }
    }))
  }

  const handleAddPaymentInline = () => {
    setPaymentEvents([
      ...paymentEvents,
      {
        tempId: uuidv4(),
        origin: 'new',
        order: paymentEvents.length + 1,
        contratoEP_desc: '',
        contratoEP_vlr: '',
        contratoEP_prazo: '',
        contratoEP_dtPrev: null,
        recTp_id: { recTp_id: 6 },
      },
    ])
  }

  const updatePaymentByTempId = (tempId, field, value) => {
    setPaymentEvents((prev) => prev.map((p) => {
      if (p.tempId !== tempId && String(p.contratoEP_id) !== String(tempId)) return p
      return { ...p, [field]: value }
    }))
  }

  /*
  const handleProductOrder = (type, index) => {

    const to = type === 'up'
      ? index - 1
      : type === 'down'
        ? index + 1
        : null

    if (typeof to === 'number') {
      const newProducts = changePosition([...products], index, to)

      setProducts(newProducts)
    }

    return null
  }


  const handlePaymentEventOrder = (type, index) => {

      const to = type === 'up'
        ? index - 1
        : type === 'down'
          ? index + 1
          : null

      if (typeof to === 'number') {
        const newPaymentEvents = changePosition([...paymentEvents], index, to)

        setPaymentEvents(newPaymentEvents)

      }

      return null
  }
  */


  const handleDeleteProduct = async (productIndex) => {

    const { tempId } = products[productIndex];
    const { contratoEP_id } = products[productIndex];
    const product = products[productIndex]

    // Aditivo / itens do cronograma em memória: existentes soft-delete; novos só saem do form
    if (props.isAditivoMode || product?.origin === 'existing' || product?.origin === 'new') {
      const linkedEps = paymentEvents.filter(pe =>
        (tempId && pe.productId === tempId)
        || (product.paymentId && pe.tempId === product.paymentId)
        || (product.contratoEP_id && pe.contratoEP_id === product.contratoEP_id)
        || (product.contratoProd_id && pe.contratoProd_id === product.contratoProd_id)
      )

      if (product?.contratoProd_id && product?.origin !== 'new') {
        await update('contratoProd', product.contratoProd_id, { contratoProd_ativo: 0 })
      }

      for (const pe of linkedEps) {
        if (pe?.contratoEP_id && pe?.origin !== 'new') {
          await update('contratoEP', pe.contratoEP_id, { contratoEP_ativo: 0 })
        }
      }

      const newProducts = [...products]
      newProducts.splice(productIndex, 1)
      setProducts(newProducts)
      if (linkedEps.length > 0) {
        const removeKeys = new Set(linkedEps.map(pe => pe.tempId || pe.contratoEP_id).filter(Boolean))
        setPaymentEvents(paymentEvents.filter(pe =>
          !removeKeys.has(pe.tempId) && !removeKeys.has(pe.contratoEP_id)
        ))
      }
      return
    }

    if (tempId) {
      const paymentEventsFiltered = paymentEvents.filter(pe => pe.productId === tempId)

      if (paymentEventsFiltered?.length > 0) return setOpenDeleteProductModal(true)
    } else if (contratoEP_id) {
      const paymentEventsFiltered = paymentEvents.filter(pe => pe.contratoEP_id === contratoEP_id)

      if (paymentEventsFiltered?.length > 0) return setOpenDeleteProductModal(true)
    } else if (!tempId && !contratoEP_id) {
      await update('contratoProd', products[productIndex].contratoProd_id, { contratoProd_ativo: 0 })
    }

    const newProducts = [...products];

    newProducts.splice(productIndex, 1)

    setProducts(newProducts)

    return
  }

  const handleAddProduct = () => {

    const productTempId = uuidv4()
    const paymentTempId = uuidv4()

    if (addProductData.hasPaymentEvent) {
      const paymentEvent = {
        tempId: paymentTempId,
        origin: 'new',
        order: paymentEvents.length + 1,
        recTp_id: {
          recTp_id: 1,
          recTp_nome: 'Produto',
        },
        contratoEP_desc: addProductData.contratoProd_desc,
        contratoEP_vlr: addProductData.contratoEP_vlr,
        contratoEP_prazo: addProductData.contratoEP_prazo,
        contratoEP_dtPrev: addProductData.contratoEP_dtPrev,
        productId: productTempId,
      }

      setPaymentEvents([...paymentEvents, paymentEvent])

      const product = {
        tempId: productTempId,
        paymentId: paymentTempId,
        order: products.length + 1,
        ...addProductData,
        origin: 'new',
      }

      setProducts([...products, product])

    } else {
      const product = {
        tempId: productTempId,
        order: products.length + 1,
        ...addProductData,
        origin: 'new',
      }

      setProducts([...products, product])
    }

    setAddPaymentData({});
    setAddProductData({});
    setOpenAddProductModal(false);

  }

  const handleEditProduct = async () => {

    try {

      if (editProductData.tempId) {

        const index = products.findIndex(p => p.tempId === editProductData.tempId)

        products[index] = editProductData

        const paymentEventIndex = paymentEvents.findIndex(pe => pe.productId === editProductData.tempId)


        if (paymentEventIndex >= 0) {


          if (editProductData.hasPaymentEvent) {

            paymentEvents[paymentEventIndex] = {
              ...paymentEvents[paymentEventIndex],
              contratoEP_desc: editProductData.contratoProd_desc,
              contratoEP_vlr: editProductData.contratoEP_vlr,
              contratoEP_prazo: editProductData.contratoEP_prazo,
              contratoEP_dtPrev: editProductData.contratoEP_dtPrev,
            }
          } else {

            paymentEvents.splice(paymentEventIndex, 1)

          }
        } else if (editProductData.hasPaymentEvent) {

          const paymentEvent = {
            tempId: uuidv4(),
            origin: 'new',
            order: paymentEvents.length + 1,
            recTp_id: {
              recTp_id: 1,
              recTp_nome: 'Produto',
            },
            contratoEP_desc: editProductData.contratoProd_desc,
            contratoEP_vlr: editProductData.contratoEP_vlr,
            contratoEP_prazo: editProductData.contratoEP_prazo,
            contratoEP_dtPrev: editProductData.contratoEP_dtPrev,
            productId: editProductData.tempId,
          }
          paymentEvents.push(paymentEvent)

          products[index] = { ...editProductData, paymentId: paymentEvent.tempId }

        }
      }

      else if (editProductData.contratoProd_id) {


        const index = products.findIndex(p => p.contratoProd_id === editProductData.contratoProd_id)

        products[index] = editProductData

        const productUpdateBody = {
          action: 'update',
          table: 'contratoProd',
          data: {
            contratoProd_id: editProductData.contratoProd_id,
            contratoProd_desc: editProductData.contratoProd_desc,
            contratoProd_prazo: editProductData.contratoProd_prazo,
            contratoProd_dtPrev: formatDateValue(editProductData.contratoProd_dtPrev, 'YYYY-MM-DD', null),
            contratoProd_ord: index + 1,
          }
        }

        const prodUpdated = await oikosApi.post('/', productUpdateBody);
        console.log('prodUpdated', prodUpdated)

        const paymentEventIndex = paymentEvents.findIndex(pe => products[index].contratoEP_id === pe.contratoEP_id);
        const productsWithPaymentEventFromDatabase = paymentEvents.find(pe => products[index].contratoEP_id === pe.contratoEP_id);
        console.log(productsWithPaymentEventFromDatabase);

        if (editProductData.hasPaymentEvent) {


          paymentEvents[paymentEventIndex] = {
            ...paymentEvents[paymentEventIndex],
            contratoEP_desc: editPaymentData.contratoEP_desc,
            contratoEP_vlr: editPaymentData.contratoEP_vlr,
            contratoEP_prazo: editPaymentData.contratoEP_prazo,
            contratoEP_dtPrev: formatDateValue(editPaymentData.contratoEP_dtPrev, 'YYYY-MM-DD', null),
          }

        } else if (editProductData.hasPaymentEvent) {

          const paymentEvent = {
            tempId: uuidv4(),
            order: paymentEvents.length + 1,
            recTp_id: {
              recTp_id: 1,
              recTp_nome: 'Produto',
            },
            contratoEP_desc: editProductData.contratoEP_desc,
            contratoEP_vlr: editProductData.contratoEP_vlr,
            contratoEP_prazo: editProductData.contratoEP_prazo,
            contratoEP_dtPrev: formatDateValue(editProductData.contratoEP_dtPrev, 'YYYY-MM-DD', null),
            productId: editProductData.tempId,
          }

          paymentEvents.push(paymentEvent)

        }

        if (paymentEvents[paymentEventIndex].contratoEP_id) {

          paymentEvents[paymentEventIndex] = {
            ...paymentEvents[paymentEventIndex],
            contratoEP_desc: editPaymentData.contratoEP_desc,
            contratoEP_vlr: editPaymentData.contratoEP_vlr,
            contratoEP_prazo: editPaymentData.contratoEP_prazo,
            contratoEP_dtPrev: formatDateValue(editPaymentData.contratoEP_dtPrev, 'YYYY-MM-DD', null),
          }

          const paymentUpdateBody = {
            contratoEP_desc: paymentEvents[paymentEventIndex].contratoEP_desc,
            contratoEP_vlr: paymentEvents[paymentEventIndex].contratoEP_vlr,
            contratoEP_prazo: paymentEvents[paymentEventIndex].contratoEP_prazo,
            contratoEP_dtPrev: formatDateValue(editPaymentData.contratoEP_dtPrev, 'YYYY-MM-DD', null),
          }

          await update('contratoEP', paymentEvents[paymentEventIndex].contratoEP_id, paymentUpdateBody)

        }

      }


    } catch (e) {
      console.log('erro', e)
    }


    setPaymentEvents(paymentEvents);
    setProducts(products)
    setEditProductData({});
    setOpenEditProductModal(false);
  }

  const handleEditPayment = async () => {

    if (!editPaymentData.contratoEP_id && !editPaymentData.fromDataBase) {
      const paymentEventIndex = paymentEvents.findIndex(pe => pe.tempId === editPaymentData.tempId)

      if (paymentEventIndex >= 0) {
        paymentEvents[paymentEventIndex] = { ...editPaymentData }
      }
      if (editPaymentData.productId) {
        const productIndex = products.findIndex(p => p.tempId === editPaymentData.productId)
        const product = products.find(p => p.tempId === editPaymentData.productId)
        if (productIndex >= 0) {

          products[productIndex] = { ...product, ...editProductData }
          paymentEvents[paymentEventIndex] = { ...editPaymentData, contratoEP_desc: products[productIndex].contratoEP_desc, contratoEP_dtPrev: products[productIndex].contratoEP_dtPrev, contratoEP_prazo: products[productIndex].contratoEP_prazo, contratoEP_vlr: products[productIndex].contratoEP_vlr }
        }
      }
    } else if (editPaymentData.contratoEP_id) {

      const paymentEventIndex = paymentEvents.findIndex(pe => pe.contratoEP_id === editPaymentData.contratoEP_id)
      if (paymentEventIndex >= 0) {

        paymentEvents[paymentEventIndex] = { ...editPaymentData }

        const paymentEventBody = {
          contratoEP_desc: editPaymentData.contratoEP_desc,
          contratoEP_vlr: editPaymentData.contratoEP_vlr,
          contratoEP_prazo: editPaymentData.contratoEP_prazo,
          contratoEP_dtPrev: formatDateValue(editPaymentData.contratoEP_dtPrev, 'YYYY-MM-DD', null),
        }

        await update('contratoEP', editPaymentData.contratoEP_id, paymentEventBody)
      }
    }

    setPaymentEvents(paymentEvents);
    setProducts(products)
    setEditProductData({});
    setOpenEditPaymentModal(false);
  }

  const handleAddPayment = (row = {}) => {

    const tempId = uuidv4();

    const paymentEvent = {
      ...addPaymentData,
      tempId,
      origin: 'new',
      order: paymentEvents.length + 1,
    }

    console.log('paymentEvent', paymentEvent)

    setPaymentEvents([...paymentEvents, paymentEvent])

    if (addPaymentData.productId) {
      const obj = products.find(p => p.tempId === addPaymentData.productId);
      obj.paymentId = tempId
    }

    if (addPaymentData.contratoProd_id) {
      const obj = products.find(p => p.contratoProd_id === addPaymentData.contratoProd_id);
      obj.paymentId = tempId
    }

    setAddPaymentData({});
    setOpenAddPaymentEventModal(false);
  }

  const handleDeletePayment = async (paymentIndex) => {
    const payment = paymentEvents[paymentIndex] || deletePaymentData

    // Aditivo: soft-delete de existentes; novos só saem do formulário
    if (props.isAditivoMode || payment?.origin === 'existing' || payment?.origin === 'new') {
      if (payment?.contratoEP_id && payment?.origin !== 'new') {
        await update('contratoEP', payment.contratoEP_id, { contratoEP_ativo: 0 })
      }

      const productsToDelete = products.filter((p) => {
        if (payment?.tempId && p.tempId && p.tempId === payment.productId) return true
        if (payment?.tempId && p.paymentId && p.paymentId === payment.tempId) return true
        if (payment?.contratoEP_id && p.contratoEP_id === payment.contratoEP_id) return true
        if (payment?.contratoProd_id && p.contratoProd_id === payment.contratoProd_id) return true
        if (payment?.produtosMedicaoComposta?.includes?.(p.tempId)) return true
        if (payment?.produtosMedicaoComposta?.includes?.(p.contratoProd_id)) return true
        return false
      })

      for (const product of productsToDelete) {
        if (product.contratoProd_id && product.origin !== 'new') {
          await update('contratoProd', product.contratoProd_id, { contratoProd_ativo: 0 })
        }
      }

      const removeProdKeys = new Set(
        productsToDelete.map(p => p.tempId || p.contratoProd_id).filter(Boolean)
      )
      setProducts(products.filter(p =>
        !removeProdKeys.has(p.tempId) && !removeProdKeys.has(p.contratoProd_id)
      ))

      const newPaymentEvents = [...paymentEvents]
      newPaymentEvents.splice(paymentIndex, 1)
      setPaymentEvents(newPaymentEvents)
      setOpenModalConfirmEPDelete(false)
      return
    }

    if (deletePaymentData.contratoEP_id) {
      const deletePaymentBody = {
        action: 'delete',
        table: 'contratoEP',
        data: {
          contratoEP_id: deletePaymentData.contratoEP_id,
        },
      }

      const deletedPaymentRes = await oikosApi.post('/', deletePaymentBody)

      const productsToDelete = products.filter((p) => {
        if (p.tempId && p.tempId === deletePaymentData.productId) return true
        else if (produtosMedicaoComposta.includes(p.tempId)) return true
        else if (produtosMedicaoComposta.includes(p.contratoProd_id)) return true
        else if (p.contratoProd_id && p.contratoEP_id === deletePaymentData.contratoEP_id) return true
        else return false;
      })

      console.log('productsToDelete', productsToDelete)

      const newProducts = [...products];

      for (const product of productsToDelete) {

        if (product.contratoProd_id) {
          console.log('teste 5')

          const deleteProductBody = {
            action: 'delete',
            table: 'contratoProd',
            data: {
              contratoProd_id: product.contratoProd_id,
            },
          }

          const deletedProdRes = await oikosApi.post('/', deleteProductBody)

          const productIndexToDelete = newProducts.findIndex((p) => {
            if (p.contratoProd_id && p.contratoProd_id === product.contratoProd_id) return true
          })

          console.log(productIndexToDelete)

          console.log('newProducts before', newProducts);

          newProducts.splice(productIndexToDelete, 1);

          console.log('newProducts', newProducts);

        } else if (product.tempId) {

          console.log('teste 4')

          const productIndexToDelete = newProducts.findIndex((p) => {
            if (p.tempId && p.tempId === product.tempId) return true;
          })

          newProducts.splice(productIndexToDelete, 1);

          console.log('newProducts', newProducts);

        }
      }

      setProducts(newProducts);
    } else if (deletePaymentData.tempId) {

      const productsToDelete = products.filter((p) => {
        if (p.tempId && p.tempId === deletePaymentData.productId) return true
        else if (produtosMedicaoComposta.includes(p.tempId)) return true
        else if (produtosMedicaoComposta.includes(p.contratoProd_id)) return true
        else if (p.contratoProd_id && p.contratoEP_id === deletePaymentData.contratoEP_id) return true
        else return false;
      })

      console.log('productsToDelete', productsToDelete)

      const newProducts = [...products];

      for (const product of productsToDelete) {

        if (product.contratoProd_id) {
          console.log('teste 5')

          const deleteProductBody = {
            action: 'delete',
            table: 'contratoProd',
            data: {
              contratoProd_id: product.contratoProd_id,
            },
          }

          const deletedProdRes = await oikosApi.post('/', deleteProductBody)

          const productIndexToDelete = newProducts.findIndex((p) => {
            if (p.contratoProd_id && p.contratoProd_id === product.contratoProd_id) return true
          })

          console.log(productIndexToDelete)

          console.log('newProducts before', newProducts);

          newProducts.splice(productIndexToDelete, 1);

          console.log('newProducts', newProducts);

        } else if (product.tempId) {

          console.log('teste 4')

          const productIndexToDelete = newProducts.findIndex((p) => {
            if (p.tempId && p.tempId === product.tempId) return true;
          })

          newProducts.splice(productIndexToDelete, 1);

          console.log('newProducts', newProducts);

        }
      }

      setProducts(newProducts);
    }



    const newPaymentEvents = [...paymentEvents];

    newPaymentEvents.splice(paymentIndex, 1);

    setPaymentEvents(newPaymentEvents);

    setOpenModalConfirmEPDelete(false)
  }

  const checkEventsGlobal = () => {
    const contractGlobalValue = Number(valorGlobal) || Number(0)
    const paymentEventsSum = paymentEvents.length > 0
      ? Number(paymentEvents.map(pe => pe.contratoEP_vlr).reduce((total, current) => Number(total) + Number(current)))
      : 0

    if (contractGlobalValue === 0 && paymentEvents.length === 0) {
      return true;
    }

    return ((paymentEvents.length > 0) && contractGlobalValue === symmetricRound(paymentEventsSum))
  }

  const handleAddContractSubmit = async () => {
    try {
      setAddContractIsLoading(true);

      const { addContractDataDraft } = props

      const instLabelLower = String(getInstLabel(data.contratoInst_id)).toLowerCase().trim();
      const isAdit = props.isAditivoMode && instLabelLower === 'aditamento';
      const isApost = props.isAditivoMode && instLabelLower === 'apostilamento';

      let contractGlobalValue = Number(valorGlobal) || Number(0)
      if (isAdit && data.aditamento_valor_sinal === 'supressao') {
        contractGlobalValue = contractGlobalValue * -1;
      }
      console.log(1);

      if (!props.isAditivoMode && !checkEventsGlobal()) {
        notifyError('A soma dos Eventos de Pagamento deve ser igual ao Valor Global do Contrato.')
        console.log(2);
        return setAddContractIsLoading(false);
      }

      if (!props.isAditivoMode && !data.areaAtua_id) {
        notifyError('O cliente deve ter Area de Atuação.')
        console.log(3);
        return setAddContractIsLoading(false);
      }

      const check = runChecks();
      console.log(4);
      if (!check) {
        console.log(5);
        return setAddContractIsLoading(false);
      }

      if (data.pj_emailPrin && data.pj_emailPrin != '') {
        console.log(6);
        const verifyEmail = validateEmail(data.pj_emailPrin);
        if (verifyEmail && (data.pj_emailPrin != props.data.data.pj_emailPrin)) {
          console.log(7);
          update('pj', data.contrato_contratante, { pj_emailPrin: data.pj_emailPrin });
        } else if (!verifyEmail) {
          console.log(8);
          return notifyError('Email inválido')
        }
      }

      const contratante = legalEntities.find(p => p.value === data.contrato_contratante)
      const contratada = legalEntities.find(p => p.value === data.contrato_contratada)

      // Cria um registro na tabela de contratos
      const contractBody = sanitizeOikosPayload({
        // sp: Number(addContractDataDraft?.SPId) || undefined,
        oport_id: Number(addContractDataDraft?.SPId) || undefined,
        contrato_num: data.contrato_num || undefined,
        contrato_dtProp: data.contrato_dtProp ? moment(data.contrato_dtProp).format('YYYY-MM-DD') : undefined,
        contrato_contratada: data.contrato_contratada || undefined,
        contrato_contratante: data.contrato_contratante || undefined,
        contrato_obj: data.contrato_obj?.trim() || undefined,
        contrato_dtAssin: data.contrato_dtAssin ? moment(data.contrato_dtAssin).format('YYYY-MM-DD') : undefined,
        contrato_dtIniVig: data.contrato_dtIniVig ? moment(data.contrato_dtIniVig).format('YYYY-MM-DD') : undefined,
        contrato_dtNotificacao: data.contrato_dtNotificacao ? moment(data.contrato_dtNotificacao).format('YYYY-MM-DD') : undefined,
        contrato_dtRescisao: data.contrato_dtRescisao ? moment(data.contrato_dtRescisao).format('YYYY-MM-DD') : undefined,
        contrato_prazoVigencia: data.contrato_prazoVigencia ? moment(data.contrato_prazoVigencia).format('YYYY-MM-DD') : undefined,
        contrato_prazoExecucao: data.contrato_prazoExecucao ? moment(data.contrato_prazoExecucao).format('YYYY-MM-DD') : undefined,
        contrato_vlrGlobal: contractGlobalValue || undefined,
        contrato_fianca: Number(data.contrato_fianca) || 0,
        contrato_permiteRenovacao: Number(data.contrato_permiteRenovacao) || 0,
        contrato_dtLimFianca: data.contrato_dtLimFianca ? moment(data.contrato_dtLimFianca).format('YYYY-MM-DD') : undefined,
        contrato_indReaj_id: data.contrato_indReaj_id || undefined,
        contrato_dtBaseReaj: data.contrato_dtBaseReaj ? moment(data.contrato_dtBaseReaj).format('YYYY-MM-DD') : undefined,
        contrato_dtAnivReaj: data.contrato_dtAnivReaj ? moment(data.contrato_dtAnivReaj).format('YYYY-MM-DD') : undefined,
        contrato_aguardarOS: data.contrato_aguardarOS || undefined,
        contrato_infoPgto: data.contrato_infoPgto || undefined,
        contrato_fatorReaj: isApost && data.contrato_fatorReaj ? Number(String(data.contrato_fatorReaj).replace(',', '.')) || undefined : undefined,
        contrato_obs: data.contrato_obs?.trim() || undefined,
        contratoInst_id: data.contratoInst_id || undefined,
        contrato_original: data.contrato_original || undefined,
        contrato_codTrib: data.contrato_codTrib || undefined,
        contrato_aliqISS: data.contrato_aliqISS || undefined,
        contrato_munISS: data.contrato_munISS || undefined,
        contratoAlterTp_id: (isApost && !data.contratoAlterTp_id) ? (selContratoAlterTp?.find(opt => String(opt.label).toLowerCase().trim() === 'reajuste de preço')?.value) : (data.contratoAlterTp_id || undefined),
        contrato_cadastro: 1,
        contrato_ativo: 1,
      })

      const contractUpdatedId = data.contrato_id
        ? await update('contrato', data.contrato_id, contractBody)
        : await insert('contrato', contractBody);

      if (data.areaAtua_id) {
        await update('pj', data.contrato_contratante, { areaAtua_id: data.areaAtua_id });
      }

      // Cria registros dos produtos e eventos de pagamento
      if (contractUpdatedId && (products.length > 0 || paymentEvents.length > 0)) {
        const resolveRecTpId = (paymentEvent) => {
          if (paymentEvent?.recTp_id?.recTp_id) return paymentEvent.recTp_id.recTp_id
          if (typeof paymentEvent?.recTp_id === 'number') return paymentEvent.recTp_id
          if (paymentEvent?.productId || paymentEvent?.contratoProd_id) return 1
          return 6
        }
        const safeTrim = (value) => (value == null ? '' : String(value).trim())

        const newPaymentEventsFiltered = paymentEvents.filter(pe => shouldInsertCronogramaItem(pe, 'contratoEP_id'))
        const existingPaymentEvents = paymentEvents.filter(pe =>
          isExistingCronogramaItem(pe) && pe.contratoEP_id
        )
        const epIdByTempId = {}

        for (const paymentEvent of existingPaymentEvents) {
          await update('contratoEP', paymentEvent.contratoEP_id, sanitizeOikosPayload({
            contratoEP_desc: safeTrim(paymentEvent.contratoEP_desc) || undefined,
            contratoEP_prazo: paymentEvent.contratoEP_prazo,
            contratoEP_vlr: Number(paymentEvent.contratoEP_vlr) || 0,
            contratoEP_ord: paymentEvents.indexOf(paymentEvent) + 1,
            recTp_id: resolveRecTpId(paymentEvent),
          }))
        }

        for (const paymentEvent of newPaymentEventsFiltered) {
          const paymentEventBody = {
            action: 'insert',
            table: 'contratoEP',
            data: sanitizeOikosPayload({
              contrato_id: contractUpdatedId,
              contratoEP_desc: safeTrim(paymentEvent.contratoEP_desc) || undefined,
              contratoEP_prazo: paymentEvent.contratoEP_prazo,
              contratoEP_vlr: Number(paymentEvent.contratoEP_vlr) || 0,
              contratoEP_ord: paymentEvents.indexOf(paymentEvent) + 1,
              recTp_id: resolveRecTpId(paymentEvent),
            }),
          }

          const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
          const createdEpId = paymentEventCreated?.data?.[0]?.contratoEP_id
          if (paymentEvent.tempId && createdEpId) {
            epIdByTempId[paymentEvent.tempId] = createdEpId
          }

          if (paymentEvent.produtosMedicaoComposta?.length > 0 && createdEpId) {
            for (const produtoMedicaoComposta of paymentEvent.produtosMedicaoComposta) {
              const produtoTempId = products.find(product => product.tempId === produtoMedicaoComposta)
              const produtoContratoProdId = products.find(product => product.contratoProd_id === produtoMedicaoComposta)

              if (produtoTempId && shouldInsertCronogramaItem(produtoTempId, 'contratoProd_id')) {
                await oikosApi.post('/', {
                  action: 'insert',
                  table: 'contratoProd',
                  data: sanitizeOikosPayload({
                    contrato_id: contractUpdatedId,
                    contratoProd_desc: safeTrim(produtoTempId.contratoProd_desc) || undefined,
                    contratoProd_prazo: produtoTempId.contratoProd_prazo,
                    contratoEP_id: createdEpId,
                    contratoProd_ord: products.indexOf(produtoTempId) + 1,
                  }),
                })
              } else if (produtoContratoProdId?.contratoProd_id) {
                await oikosApi.post('/', {
                  action: 'update',
                  table: 'contratoProd',
                  data: sanitizeOikosPayload({
                    contratoProd_id: produtoContratoProdId.contratoProd_id,
                    contratoProd_desc: safeTrim(produtoContratoProdId.contratoProd_desc) || undefined,
                    contratoProd_prazo: produtoContratoProdId.contratoProd_prazo,
                    contratoEP_id: createdEpId,
                    contratoProd_ord: products.indexOf(produtoContratoProdId) + 1,
                  }),
                })
              }
            }
          } else if (createdEpId) {
            const produto = products
              .filter(product => shouldInsertCronogramaItem(product, 'contratoProd_id'))
              .find(product => product.tempId === paymentEvent.productId)
            if (produto) {
              await oikosApi.post('/', {
                action: 'insert',
                table: 'contratoProd',
                data: sanitizeOikosPayload({
                  contrato_id: contractUpdatedId,
                  contratoProd_desc: safeTrim(produto.contratoProd_desc) || undefined,
                  contratoProd_prazo: produto.contratoProd_prazo,
                  contratoProd_ord: products.indexOf(produto) + 1,
                  contratoEP_id: createdEpId,
                }),
              })
            }
          }
        }

        const existingProductsToUpdate = products.filter(product =>
          isExistingCronogramaItem(product) && product.contratoProd_id
        )
        for (const product of existingProductsToUpdate) {
          await update('contratoProd', product.contratoProd_id, sanitizeOikosPayload({
            contratoProd_desc: safeTrim(product.contratoProd_desc) || undefined,
            contratoProd_prazo: product.contratoProd_prazo,
            contratoProd_ord: products.indexOf(product) + 1,
          }))
        }

        const productsToInsert = products.filter(product =>
          shouldInsertCronogramaItem(product, 'contratoProd_id')
          && !product.paymentId
          && !produtosMedicaoComposta.includes(product.tempId)
          && !newPaymentEventsFiltered.some(pe => pe.productId === product.tempId)
        )

        for (const product of productsToInsert) {
          await oikosApi.post('/', {
            action: 'insert',
            table: 'contratoProd',
            data: sanitizeOikosPayload({
              contrato_id: contractUpdatedId,
              contratoProd_desc: safeTrim(product.contratoProd_desc) || undefined,
              contratoProd_prazo: product.contratoProd_prazo,
              contratoProd_ord: products.indexOf(product) + 1,
              contratoEP_id: product.paymentId ? epIdByTempId[product.paymentId] : undefined,
            }),
          })
        }
      }

      // Faz upload do pdf do contrato
      if (contratoFile.length > 0) {

        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: sanitizeOikosPayload({
            tpDocumento_id: 6,
            documento_desc: `Contrato n. ${data.contrato_num} - Contratante ${contratante?.label || 'N/A'} x Contratada ${contratada?.label || 'N/A'}`,
            documento_iniVig: formatDateValue(data.contrato_dtIniVig || data.contrato_dtAssin, 'YYYY-MM-DD', undefined),
            documento_fimVig: formatDateValue(data.contrato_prazoVigencia, 'YYYY-MM-DD', undefined),
            documento_dtEmissao: formatDateValue(data.contrato_dtAssin, 'YYYY-MM-DD', undefined),
            privacidade_id: 2,
          }),
        }

        const documentCreated = await oikosApi.post('/', documentBody)


        // Cria uma vinculação entre o contrato e a tabela de documentos
        if (documentCreated.data[0].documento_id && contractUpdatedId) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractUpdatedId,
            },
          }

          const vinculationCreated = await oikosApi.post('/', vinculationBody)

        }

        const formData = new FormData()
        formData.append('file', new Blob([contratoFile[0].data], { type: contratoFile[0].data.type }), contratoFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', contratoFile[0].data.path)

        const res = await oikosApi.post('/', formData)

      }

      // Faz upload do pdf da proposta comercial
      if (propostaComercialFile.length > 0) {
        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 21,
            documento_desc: 'Proposta Comercial',
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre a proposta comercial e o contrato
        if (documentCreated.data[0].documento_id && contractUpdatedId) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractUpdatedId,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        const formData = new FormData()
        formData.append('file', new Blob([propostaComercialFile[0].data], { type: propostaComercialFile[0].data.type }), propostaComercialFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', propostaComercialFile[0].data.path)

        const res = await oikosApi.post('/', formData)

      }

      // Faz upload do pdf do termo de referência
      if (termoDeReferenciaFile.length > 0) {
        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 22,
            documento_desc: 'Termo de Referência - TR',
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o termo de referência e o contrato
        if (documentCreated.data[0].documento_id && contractUpdatedId) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractUpdatedId,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        const formData = new FormData()
        formData.append('file', new Blob([termoDeReferenciaFile[0].data], { type: termoDeReferenciaFile[0].data.type }), termoDeReferenciaFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', termoDeReferenciaFile[0].data.path)

        const res = await oikosApi.post('/', formData)

      }

      // Faz upload dos anexos gerais
      if (files.length > 0) {

        const hasFilesWithoutName = files.filter((file) => {
          if (file.props?.description === undefined || file.props?.description === '') {
            return true
          }
        })

        if (hasFilesWithoutName?.length > 0) {
          notifyError('É necessário nomear os arquivos anexados.')
          return setAddContractIsLoading(false);
        }

        await Promise.all(files.map(async file => {
          // Cria um registro na tabela de documentos para cada arquivo
          const documentBody = {
            action: 'insert',
            table: 'documento',
            data: {
              tpDocumento_id: file.props?.documentType?.tpDocumento_id,
              documento_desc: file.props?.description || 'Documento sem título',
              documento_iniVig: undefined,
              documento_fimVig: undefined,
              documento_dtEmissao: undefined,
              documento_prazo: undefined,
              documento_ref: undefined,
              privacidade_id: 2,
            },
          }
          const documentCreated = await oikosApi.post('/', documentBody)

          // Cria uma vinculação entre o documento (anexo) e o contrato
          if (documentCreated.data[0].documento_id && contractUpdatedId) {
            const vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                documentoVinc_tabRef: 'contrato',
                documentoVinc_tabId: contractUpdatedId,
              },
            }
            await oikosApi.post('/', vinculationBody)
          }

          // Faz upload do arquivo e registra na tabela 'arquivo'
          const formData = new FormData()
          formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', file.data.path)
          const fileUploadRes = await oikosApi.post('/', formData)

        }))
      }

      console.log(10);

      // Atualiza status da oportunidade/licitação no SharePoint para Contratada
      /*
      if (type === 'privado') {
        const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
        const listId = '24e2b5f2-3b68-40f3-96a8-d154f82986d1'
        const itemId = addContractDataDraft.SPId
        const opportunityUpdated = await graphClient
          .api(`/sites/${siteId}/lists/${listId}/items/${itemId}/fields`)
          .update({
            Status0: 'Contratada',
            Status: 'Ganho',
            Datacontratada: moment().format('YYYY-MM-DDThh:mm:ss[Z]'),
          })

      } else if (type === 'publico') {
        const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,32cf4926-8ed5-475c-918f-6b48d3e42b49'
        const listId = 'df3f359b-f817-44b5-a140-e384223bf177'
        const itemId = addContractDataDraft.SPId
        const opportunityUpdated = await graphClient
          .api(`/sites/${siteId}/lists/${listId}/items/${itemId}/fields`)
          .update({
            Situa_x00e7__x00e3_o: 'Contratada',
          })

      }
      await fetch('https://oikos.ecoss.is/oikos/_webhook_oikos2sp_contracts.php')
      */
      // Cria registro do contrato na lista do sharepoint
      //sendMail('gerencia.tecnico@ecossis.com.br', 'Contrato ' + data.contrato_num + ' cadastrado no Oikos', data.contrato_obj, 'oikos@ecossis.com.br')

      if (data.contratoInst_id !== 1 && data.proj_id_contrato_original) {
        await update('proj', data.proj_id_contrato_original, { proj_abert: 0 })
      }

      console.log(11);

      // Abrir projeto / cad_prod_rec só para contrato original — não para aditivo
      if (!props.isAditivoMode && Number(data.contratoInst_id) === 1) {
        await openProjectAndRegisterRecAndProd(contractUpdatedId);
      }

      notifySuccess(props.isAditivoMode ? 'Aditivo cadastrado com sucesso.' : 'Contrato cadastrado com sucesso.')
      props.preloading();
      setAddContractIsLoading(false);
      /*
      setData({});
      setProducts([]);
      setPaymentEvents([]);
      */
      setContratoFile([]);
      setPropostaComercialFile([]);
      setTermoDeReferenciaFile([]);
      setFiles([]);

      handleClose();
    } catch (e) {
      notifyError('Erro ao cadastrar contrato: ' + formatApiError(e))
      console.error('handleAddContractSubmit error:', e)

      setAddContractIsLoading(false);
    }
  }

  const runChecks = () => {

    const checks = [
      {
        condition: !props.isAditivoMode && contratoFile.length <= 0 && linkContratoFile.length <= 0,
        message: 'É necessário anexar o arquivo do contrato antes de confirmar.',
      },
      {
        condition: data.contratoInst_id !== 1 && !data.contrato_original,
        message: 'É necessário selecionar contrato original.',
      },
      {
        condition: props.isAditivoMode && !['rescisão', 'rescisao', 'apostilamento'].includes(getInstLabel(data.contratoInst_id).toLowerCase().trim()) && !data.contratoAlterTp_id,
        message: 'É necessário selecionar o Motivo da Alteração.',
      },
      {
        condition: props.isAditivoMode && getInstLabel(data.contratoInst_id).toLowerCase().trim() === 'apostilamento' && !data.contrato_fatorReaj,
        message: 'É necessário preencher o Fator de Reajuste.',
      },
      {
        condition: !props.isAditivoMode && !data.contrato_num,
        message: 'É necessário número do contrato.',
      },
      {
        condition: !props.isAditivoMode && !data.contratoInst_id,
        message: 'É necessário Alteração contratual.',
      },
      {
        condition: !props.isAditivoMode && !data.contrato_contratante,
        message: 'É necessário selecionar contratante.',
      },
      {
        condition: !props.isAditivoMode && !data.contrato_contratada,
        message: 'É necessário selecionar contratada.',
      },
      {
        condition: (!props.isAditivoMode || (props.isAditivoMode && String(selContratoAlterTp?.find(x => String(x.value) === String(data.contratoAlterTp_id))?.label).toLowerCase().trim() === 'aditivo de objeto')) && !data.contrato_obj,
        message: 'É necessário preencher o objeto do contrato.',
      },
      {
        condition: !data.contrato_dtAssin,
        message: 'É necessário data assinatura.',
      },
      {
        condition: props.isAditivoMode
          && !['rescisão', 'rescisao'].includes(String(getInstLabel(data.contratoInst_id)).toLowerCase().trim())
          && !data.contrato_dtIniVig,
        message: 'É necessário data de início de vigência do aditivo.',
      },
      {
        condition: (!props.isAditivoMode || (props.isAditivoMode && checkVisible('contrato_prazoVigencia'))) && !data.contrato_prazoVigencia,
        message: 'É necessário prazo de vigência.',
      },
      {
        condition: props.isAditivoMode && checkVisible('valorGlobal') && (!valorGlobal || Number(valorGlobal) <= 0),
        message: 'É necessário valor global.',
      },
      {
        condition: (!props.isAditivoMode || (props.isAditivoMode && checkVisible('contrato_prazoExecucao'))) && !data.contrato_prazoExecucao,
        message: 'É necessário prazo de execução.',
      },
      {
        condition: !props.isAditivoMode && !valorGlobal && data.contratoInst_id === 1,
        message: 'É necessário valor global.',
      },
      {
        condition: data.contratoInst_id === 1 && !data.contrato_dtProp,
        message: 'Necessário data da proposta se for contrato.',
      },
      {
        condition:
          !props.isAditivoMode &&
          propostaComercialFile.length <= 0 &&
          linkPropostaComercialFile.length <= 0 &&
          data.contratoInst_id,
        message: 'É necessário anexar o arquivo da proposta antes de confirmar.',
      },
      {
        condition:
          (termoDeReferenciaFile.length <= 0 && data.contratoInst_id === 1) &&
          linkTermoDeReferenciaFile.length <= 0 &&
          data.contratoInst_id,
        message: 'É necessário anexar o arquivo da proposta antes de confirmar.',
      },
      {
        condition: !props.isAditivoMode && products.length <= 0,
        message: 'É necessário preencher ao menos 1 (um) Produto antes de confirmar.',
      },
      {
        condition: !props.isAditivoMode && valorGlobal && paymentEvents.length <= 0,
        message: 'É necessário preencher ao menos 1 (um) Evento de Pagamento antes de confirmar.',
      },
      {
        condition: hasProductWithoutExpectedDate(),
        message: 'Todos os Produtos devem ter Data prevista antes de salvar e enviar.',
      },
      {
        condition: hasPaymentEventWithoutExpectedDate(),
        message: 'Todos os Eventos de Pagamento devem ter Data prevista antes de salvar e enviar.',
      },
      {
        condition: !props.isAditivoMode && checaEPeProdPrevForaDataVigencia(data.contrato_prazoVigencia),
        message: 'Data de Prevista do Produto ou Evento de Pagamento fora da data de vigência do contrato.',
      },
      {
        condition: props.isAditivoMode && checkVisible('contrato_prazoVigencia') && data.contrato_prazoVigencia && data.vigencia_consolidada && (data.aditamento_prazo_sinal === 'acrescimo' || !data.aditamento_prazo_sinal) && new Date(data.contrato_prazoVigencia).getTime() <= new Date(data.vigencia_consolidada).getTime(),
        message: 'Para acréscimo de prazo, a nova data de fim da vigência deve ser maior que a vigência atual.',
      },
      {
        condition: props.isAditivoMode && checkVisible('contrato_prazoVigencia') && data.contrato_prazoVigencia && data.vigencia_consolidada && data.aditamento_prazo_sinal === 'supressao' && new Date(data.contrato_prazoVigencia).getTime() >= new Date(data.vigencia_consolidada).getTime(),
        message: 'Para supressão de prazo, a nova data de fim da vigência deve ser menor que a vigência atual.',
      },
      {
        condition: props.isAditivoMode && checkVisible('contrato_prazoExecucao') && data.contrato_prazoExecucao && data.prazoExecucao_consolidado && (data.aditamento_prazo_sinal === 'acrescimo' || !data.aditamento_prazo_sinal) && new Date(data.contrato_prazoExecucao).getTime() <= new Date(data.prazoExecucao_consolidado).getTime(),
        message: 'Para acréscimo de prazo, o novo prazo de execução deve ser maior que o atual.',
      },
      {
        condition: props.isAditivoMode && checkVisible('contrato_prazoExecucao') && data.contrato_prazoExecucao && data.prazoExecucao_consolidado && data.aditamento_prazo_sinal === 'supressao' && new Date(data.contrato_prazoExecucao).getTime() >= new Date(data.prazoExecucao_consolidado).getTime(),
        message: 'Para supressão de prazo, o novo prazo de execução deve ser menor que o atual.',
      },
      {
        condition: (() => {
          const descs = (products || [])
            .map(p => String(p.contratoProd_desc || '').trim().toLowerCase())
            .filter(Boolean)
          return descs.length !== new Set(descs).size
        })(),
        message: 'Há produtos com a mesma descrição. Não é permitido duplicar.',
      },
      {
        condition: (() => {
          const descs = (paymentEvents || [])
            .map(p => String(p.contratoEP_desc || '').trim().toLowerCase())
            .filter(Boolean)
          return descs.length !== new Set(descs).size
        })(),
        message: 'Há eventos de pagamento com a mesma descrição. Não é permitido duplicar.',
      },
    ];

    for (const check of checks) {
      if (check.condition) {
        notifyError(check.message);
        setAddContractIsLoading(false);
        return false;
      }
    }

    return true;
  };

  /*
  // When user edits R$ input
 const handleValorChange = (value) => {
  const numeric = Number(value);
  setAddProductData({ ...addProductData, contratoEP_vlr: numeric });
  setValorInput(value);
  setPercentInput(String((100 * numeric) / valorGlobal || 0));
 };

 // When user edits % input
 const handlePercentChange = (value) => {
  const numeric = Number(value);
  const updatedValor = (valorGlobal * numeric) / 100;
  setAddProductData({ ...addProductData, contratoEP_vlr: updatedValor });
  setValorInput(String(updatedValor));
  setPercentInput(value);
 };
  */


  const handleSaveContractSubmit = async () => {
    try {
      setAddContractIsLoading(true);

      const { addContractDataDraft } = props

      const contractGlobalValue = Number(valorGlobal) || Number(0)

      const contratante = legalEntities.find(p => p.value === data.contrato_contratante)
      const contratada = legalEntities.find(p => p.value === data.contrato_contratada)

      if (data.pj_emailPrin && data.pj_emailPrin != '') {
        const verifyEmail = validateEmail(data.pj_emailPrin);
        if (verifyEmail && (data.pj_emailPrin != props.data.data.pj_emailPrin)) {
          update('pj', data.contrato_contratante, { pj_emailPrin: data.pj_emailPrin });
        } else if (!verifyEmail) {
          return notifyError('Email inválido')
        }
      }

      const check = runChecks();
      if (!check) {
        return setAddContractIsLoading(false);
      }

      // atualiza um registro na tabela de contratos
      const contractBody = sanitizeOikosPayload({
        // sp: Number(addContractDataDraft?.SPId) || undefined,
        oport_id: Number(addContractDataDraft?.SPId) || undefined,
        contrato_num: data.contrato_num || undefined,
        contrato_dtProp: data.contrato_dtProp ? moment(data.contrato_dtProp).format('YYYY-MM-DD') : undefined,
        contrato_contratada: data.contrato_contratada || undefined,
        contrato_contratante: data.contrato_contratante || undefined,
        contrato_obj: data.contrato_obj || undefined,
        contrato_dtAssin: data.contrato_dtAssin ? moment(data.contrato_dtAssin).format('YYYY-MM-DD') : undefined,
        contrato_dtIniVig: data.contrato_dtIniVig ? moment(data.contrato_dtIniVig).format('YYYY-MM-DD') : undefined,
        contrato_dtNotificacao: data.contrato_dtNotificacao ? moment(data.contrato_dtNotificacao).format('YYYY-MM-DD') : undefined,
        contrato_dtRescisao: data.contrato_dtRescisao ? moment(data.contrato_dtRescisao).format('YYYY-MM-DD') : undefined,
        contrato_prazoVigencia: data.contrato_prazoVigencia ? moment(data.contrato_prazoVigencia).format('YYYY-MM-DD') : undefined,
        contrato_prazoExecucao: data.contrato_prazoExecucao ? moment(data.contrato_prazoExecucao).format('YYYY-MM-DD') : undefined,
        contrato_vlrGlobal: contractGlobalValue || undefined,
        contrato_fianca: Number(data.contrato_fianca) || 0,
        contrato_permiteRenovacao: Number(data.contrato_permiteRenovacao) || 0,
        contrato_dtLimFianca: data.contrato_dtLimFianca ? moment(data.contrato_dtLimFianca).format('YYYY-MM-DD') : undefined,
        contrato_indReaj_id: data.contrato_indReaj_id || undefined,
        contrato_dtBaseReaj: data.contrato_dtBaseReaj ? moment(data.contrato_dtBaseReaj).format('YYYY-MM-DD') : undefined,
        contrato_dtAnivReaj: data.contrato_dtAnivReaj ? moment(data.contrato_dtAnivReaj).format('YYYY-MM-DD') : undefined,
        contrato_aguardarOS: data.contrato_aguardarOS || undefined,
        contrato_infoPgto: data.contrato_infoPgto || undefined,
        contrato_obs: data.contrato_obs || undefined,
        contratoInst_id: data.contratoInst_id || undefined,
        contratoAlterTp_id: data.contratoAlterTp_id || undefined,
        contrato_original: data.contrato_original || undefined,
        contrato_codTrib: data.contrato_codTrib || undefined,
        contrato_aliqISS: data.contrato_aliqISS || undefined,
        contrato_munISS: data.contrato_munISS || undefined,
        contrato_cadastro: 0,
        contrato_ativo: 1,
      })

      const contractUpdatedId = await update('contrato', data.contrato_id, contractBody);
      if (data.areaAtua_id) {
        const pjAreaUpdated = await update('pj', data.contrato_contratante, { areaAtua_id: data.areaAtua_id });
      }

      // Cria registros dos produtos e eventos de pagamento
      if (contractUpdatedId && (products.length > 0 || paymentEvents.length > 0)) {
        const resolveRecTpId = (paymentEvent) => {
          if (paymentEvent?.recTp_id?.recTp_id) return paymentEvent.recTp_id.recTp_id
          if (typeof paymentEvent?.recTp_id === 'number') return paymentEvent.recTp_id
          if (paymentEvent?.productId || paymentEvent?.contratoProd_id) return 1
          return 6
        }
        const safeTrim = (value) => (value == null ? '' : String(value).trim())

        const newPaymentEventsFiltered = paymentEvents.filter(pe => shouldInsertCronogramaItem(pe, 'contratoEP_id'))
        const existingPaymentEvents = paymentEvents.filter(pe =>
          isExistingCronogramaItem(pe) && pe.contratoEP_id
        )
        const epIdByTempId = {}

        for (const paymentEvent of existingPaymentEvents) {
          await update('contratoEP', paymentEvent.contratoEP_id, sanitizeOikosPayload({
            contratoEP_desc: safeTrim(paymentEvent.contratoEP_desc) || undefined,
            contratoEP_prazo: paymentEvent.contratoEP_prazo,
            contratoEP_vlr: Number(paymentEvent.contratoEP_vlr) || 0,
            contratoEP_ord: paymentEvents.indexOf(paymentEvent) + 1,
            recTp_id: resolveRecTpId(paymentEvent),
          }))
        }

        for (const paymentEvent of newPaymentEventsFiltered) {
          const paymentEventBody = {
            action: 'insert',
            table: 'contratoEP',
            data: sanitizeOikosPayload({
              contrato_id: contractUpdatedId,
              contratoEP_desc: safeTrim(paymentEvent.contratoEP_desc) || undefined,
              contratoEP_prazo: paymentEvent.contratoEP_prazo,
              contratoEP_vlr: Number(paymentEvent.contratoEP_vlr) || 0,
              contratoEP_ord: paymentEvents.indexOf(paymentEvent) + 1,
              recTp_id: resolveRecTpId(paymentEvent),
            }),
          }

          const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
          const createdEpId = paymentEventCreated?.data?.[0]?.contratoEP_id
          if (paymentEvent.tempId && createdEpId) {
            epIdByTempId[paymentEvent.tempId] = createdEpId
          }

          if (paymentEvent.produtosMedicaoComposta?.length > 0 && createdEpId) {
            for (const produtoMedicaoComposta of paymentEvent.produtosMedicaoComposta) {
              const produtoTempId = products.find(product => product.tempId === produtoMedicaoComposta)
              const produtoContratoProdId = products.find(product => product.contratoProd_id === produtoMedicaoComposta)

              if (produtoTempId && shouldInsertCronogramaItem(produtoTempId, 'contratoProd_id')) {
                await oikosApi.post('/', {
                  action: 'insert',
                  table: 'contratoProd',
                  data: sanitizeOikosPayload({
                    contrato_id: contractUpdatedId,
                    contratoProd_desc: safeTrim(produtoTempId.contratoProd_desc) || undefined,
                    contratoProd_prazo: produtoTempId.contratoProd_prazo,
                    contratoEP_id: createdEpId,
                    contratoProd_ord: products.indexOf(produtoTempId) + 1,
                  }),
                })
              } else if (produtoContratoProdId?.contratoProd_id) {
                await oikosApi.post('/', {
                  action: 'update',
                  table: 'contratoProd',
                  data: sanitizeOikosPayload({
                    contratoProd_id: produtoContratoProdId.contratoProd_id,
                    contratoProd_desc: safeTrim(produtoContratoProdId.contratoProd_desc) || undefined,
                    contratoProd_prazo: produtoContratoProdId.contratoProd_prazo,
                    contratoEP_id: createdEpId,
                    contratoProd_ord: products.indexOf(produtoContratoProdId) + 1,
                  }),
                })
              }
            }
          } else if (createdEpId) {
            const produto = products
              .filter(product => shouldInsertCronogramaItem(product, 'contratoProd_id'))
              .find(product => product.tempId === paymentEvent.productId)
            if (produto) {
              await oikosApi.post('/', {
                action: 'insert',
                table: 'contratoProd',
                data: sanitizeOikosPayload({
                  contrato_id: contractUpdatedId,
                  contratoProd_desc: safeTrim(produto.contratoProd_desc) || undefined,
                  contratoProd_prazo: produto.contratoProd_prazo,
                  contratoProd_ord: products.indexOf(produto) + 1,
                  contratoEP_id: createdEpId,
                }),
              })
            }
          }
        }

        const existingProductsToUpdate = products.filter(product =>
          isExistingCronogramaItem(product) && product.contratoProd_id
        )
        for (const product of existingProductsToUpdate) {
          await update('contratoProd', product.contratoProd_id, sanitizeOikosPayload({
            contratoProd_desc: safeTrim(product.contratoProd_desc) || undefined,
            contratoProd_prazo: product.contratoProd_prazo,
            contratoProd_ord: products.indexOf(product) + 1,
          }))
        }

        const productsToInsert = products.filter(product =>
          shouldInsertCronogramaItem(product, 'contratoProd_id')
          && !product.paymentId
          && !produtosMedicaoComposta.includes(product.tempId)
          && !newPaymentEventsFiltered.some(pe => pe.productId === product.tempId)
        )

        for (const product of productsToInsert) {
          await oikosApi.post('/', {
            action: 'insert',
            table: 'contratoProd',
            data: sanitizeOikosPayload({
              contrato_id: contractUpdatedId,
              contratoProd_desc: safeTrim(product.contratoProd_desc) || undefined,
              contratoProd_prazo: product.contratoProd_prazo,
              contratoProd_ord: products.indexOf(product) + 1,
              contratoEP_id: product.paymentId ? epIdByTempId[product.paymentId] : undefined,
            }),
          })
        }
      }

      /*
           const newPaymentEvents = paymentEvents.filter(pe => (pe.productId === product.tempId || produtosMedicaoComposta.includes(product.tempId)));
 
           if (newPaymentEvents && newPaymentEvents.length > 0) {
             for (const paymentEvent of newPaymentEvents) {
               if (paymentEvent.recTp_id.recTp_id === 1) {
                 console.log('teste 1');
 
                 const paymentEventBody = {
                   action: 'insert',
                   table: 'contratoEP',
                   data: {
                     contrato_id: contractUpdatedId,
                     contratoProd_id: productCreated.data[0].contratoProd_id,
                     contratoEP_desc: paymentEvent.contratoEP_desc,
                     contratoEP_prazo: paymentEvent.contratoEP_prazo,
                     contratoEP_dtPrev: formatDateValue(paymentEvent.contratoEP_dtPrev, 'YYYY-MM-DD', undefined),
                     contratoEP_vlr: Number(paymentEvent.contratoEP_vlr),
                     contratoEP_ord: paymentEvents.indexOf(paymentEvent) + 1,
                     recTp_id: paymentEvent.recTp_id.recTp_id,
                   },
                 }
 
                 const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
 
                 const productEventBody = {
                   action: 'update',
                   table: 'contratoProd',
                   data: {
                     contratoProd_id: productCreated.data[0].contratoProd_id,
                     contratoEP_id: paymentEventCreated.data[0].contratoEP_id,
                   },
                 }
 
                 const productEventCreated = await oikosApi.post('/', productEventBody)
 
               } else if (paymentEvent.recTp_id?.recTp_id === 6) {
                 console.log('teste 2');
 
                 const paymentEventBody = {
                   action: 'insert',
                   table: 'contratoEP',
                   data: {
                     contrato_id: contractUpdatedId,
                     contratoProd_id: productCreated.data[0].contratoProd_id,
                     contratoEP_desc: paymentEvent.contratoEP_desc,
                     contratoEP_prazo: paymentEvent.contratoEP_prazo,
                     contratoEP_dtPrev: formatDateValue(paymentEvent.contratoEP_dtPrev, 'YYYY-MM-DD', undefined),
                     contratoEP_vlr: Number(paymentEvent.contratoEP_vlr),
                     contratoEP_ord: paymentEvents.indexOf(paymentEvent) + 1,
                     recTp_id: paymentEvent.recTp_id.recTp_id,
                   },
                 }
 
                 const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
 
                 const productEventBody = {
                   action: 'update',
                   table: 'contratoProd',
                   data: {
                     contratoProd_id: productCreated.data[0].contratoProd_id,
                     contratoEP_id: paymentEventCreated.data[0].contratoEP_id,
                   },
                 }
 
                 const productEventCreated = await oikosApi.post('/', productEventBody)
 
               } else if (paymentEvent.recTp_id?.recTp_id === 6) {
                 console.log('teste 3');
 
                 const productEventBody = {
                   action: 'update',
                   table: 'contratoProd',
                   data: {
                     contratoProd_id: productCreated.data[0].contratoProd_id,
                   },
                 }
 
                 const productEventCreated = await oikosApi.post('/', productEventBody)
 
               }
             }
           }
         })
         const paymentEventsFromDatabase = paymentEvents.filter(pe => pe.contratoEP_id);
         if (paymentEventsFromDatabase.length > 0) {
           paymentEventsFromDatabase.forEach(async (paymentEvent) => {
             console.log("if contratoEP_id")
             const paymentEventBody = {
               action: 'update',
               table: 'contratoEP',
               data: {
                 contrato_id: contractUpdatedId,
                 contratoEP_desc: paymentEvent.contratoEP_desc,
                 contratoEP_id: paymentEvent.contratoEP_id,
                 contratoEP_prazo: paymentEvent.contratoEP_prazo,
                 contratoEP_dtPrev: formatDateValue(paymentEvent.contratoEP_dtPrev, 'YYYY-MM-DD', undefined),
                 contratoEP_vlr: Number(paymentEvent.contratoEP_vlr),
                 contratoEP_ord: paymentEvents.indexOf(paymentEvent) + 1,
                 recTp_id: paymentEvent.recTp_id.recTp_id,
               },
             }
 
             const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
 
             if (paymentEvent.produtosMedicaoComposta?.length > 0) {
               for (const produtoMedicaoComposta of paymentEvent.produtosMedicaoComposta) {
                 const produto = products.find(product => product.tempId === produtoMedicaoComposta);
                 const productBody = {
                   action: 'insert',
                   table: 'contratoProd',
                   data: {
                     contrato_id: contractUpdatedId,
                     contratoProd_desc: produto.contratoProd_desc,
                     contratoProd_prazo: produto.contratoProd_prazo,
                     contratoProd_dtPrev: formatDateValue(produto.contratoProd_dtPrev, 'YYYY-MM-DD', undefined),
                     contratoProd_ord: products.indexOf(produto) + 1,
                     contratoEP_id: paymentEventCreated.data[0].contratoEP_id
                   },
                 }
 
                 const productCreated = await oikosApi.post('/', productBody)
               }
             } else {
               const produto = products.find(product => product.tempId === paymentEvent.productId);
                 const productBody = {
                   action: 'insert',
                   table: 'contratoProd',
                   data: {
                     contrato_id: contractUpdatedId,
                     contratoProd_desc: produto.contratoProd_desc,
                     contratoProd_prazo: produto.contratoProd_prazo,
                     contratoProd_dtPrev: formatDateValue(produto.contratoProd_dtPrev, 'YYYY-MM-DD', undefined),
                     contratoProd_ord: products.indexOf(produto) + 1,
                     contratoEP_id: paymentEventCreated.data[0].contratoEP_id
                   },
                 }
 
                 const productCreated = await oikosApi.post('/', productBody)
             }
           })
         }
         // Cria registros dos eventos de pagamento que não estão vinculados à nenhum produto
         const paymentEventsWithoutProductsNotFromDataBase = paymentEvents.filter(pe => (!pe.productId || !pe.contratoProd_id) && !pe.contratoEP_id);
         console.log('paymentEventsWithoutProductsNotFromDataBase', paymentEventsWithoutProductsNotFromDataBase)
 
 
         if (paymentEventsWithoutProductsNotFromDataBase?.length > 0) {
           await Promise.all(paymentEventsWithoutProductsNotFromDataBase.map(async paymentEvent => {
 
             console.log('paymentEvent', paymentEvent)
 
             if (!paymentEvent.produtosMedicaoComposta) {
               const paymentEventBody = {
                 action: 'insert',
                 table: 'contratoEP',
                 data: {
                   contrato_id: contractUpdatedId,
                   contratoEP_desc: paymentEvent.contratoEP_desc,
                   contratoEP_prazo: paymentEvent.contratoEP_prazo,
                   contratoEP_dtPrev: formatDateValue(paymentEvent.contratoEP_dtPrev, 'YYYY-MM-DD', undefined),
                   contratoEP_vlr: Number(paymentEvent.contratoEP_vlr),
                   recTp_id: paymentEvent.recTp_id.recTp_id,
                 },
               }
 
               const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
             }
 
           }))
         }
         */

      // Faz upload do pdf do contrato
      if (contratoFile.length > 0) {

        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: sanitizeOikosPayload({
            tpDocumento_id: 6,
            documento_desc: `Contrato n. ${data.contrato_num} - Contratante ${contratante?.label || 'N/A'} x Contratada ${contratada?.label || 'N/A'}`,
            documento_iniVig: formatDateValue(data.contrato_dtIniVig || data.contrato_dtAssin, 'YYYY-MM-DD', undefined),
            documento_fimVig: formatDateValue(data.contrato_prazoVigencia, 'YYYY-MM-DD', undefined),
            documento_dtEmissao: formatDateValue(data.contrato_dtAssin, 'YYYY-MM-DD', undefined),
            privacidade_id: 2,
          }),
        }

        const documentCreated = await oikosApi.post('/', documentBody)


        // Cria uma vinculação entre o contrato e a tabela de documentos
        if (documentCreated.data[0].documento_id && contractUpdatedId) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractUpdatedId,
            },
          }

          const vinculationCreated = await oikosApi.post('/', vinculationBody)

        }

        const formData = new FormData()
        formData.append('file', new Blob([contratoFile[0].data], { type: contratoFile[0].data.type }), contratoFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', contratoFile[0].data.path)

        const res = await oikosApi.post('/', formData)

      }

      // Faz upload do pdf da proposta comercial
      if (propostaComercialFile.length > 0) {
        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 21,
            documento_desc: 'Proposta Comercial',
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre a proposta comercial e o contrato
        if (documentCreated.data[0].documento_id && contractUpdatedId) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractUpdatedId,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        const formData = new FormData()
        formData.append('file', new Blob([propostaComercialFile[0].data], { type: propostaComercialFile[0].data.type }), propostaComercialFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', propostaComercialFile[0].data.path)

        const res = await oikosApi.post('/', formData)

      }

      // Faz upload do pdf do termo de referência
      if (termoDeReferenciaFile.length > 0) {
        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 22,
            documento_desc: 'Termo de Referência - TR',
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o termo de referência e o contrato
        if (documentCreated.data[0].documento_id && contractUpdatedId) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractUpdatedId,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        const formData = new FormData()
        formData.append('file', new Blob([termoDeReferenciaFile[0].data], { type: termoDeReferenciaFile[0].data.type }), termoDeReferenciaFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', termoDeReferenciaFile[0].data.path)

        const res = await oikosApi.post('/', formData)

      }

      // Faz upload dos anexos gerais
      if (files.length > 0) {
        await Promise.all(files.map(async file => {
          // Cria um registro na tabela de documentos para cada arquivo
          const documentBody = {
            action: 'insert',
            table: 'documento',
            data: {
              tpDocumento_id: file.props?.documentType?.tpDocumento_id,
              documento_desc: file.props?.description || 'Documento sem título',
              documento_iniVig: undefined,
              documento_fimVig: undefined,
              documento_dtEmissao: undefined,
              documento_prazo: undefined,
              documento_ref: undefined,
              privacidade_id: 2,
            },
          }
          const documentCreated = await oikosApi.post('/', documentBody)

          // Cria uma vinculação entre o documento (anexo) e o contrato
          if (documentCreated.data[0].documento_id && contractUpdatedId) {
            const vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                documentoVinc_tabRef: 'contrato',
                documentoVinc_tabId: contractUpdatedId,
              },
            }
            await oikosApi.post('/', vinculationBody)
          }

          // Faz upload do arquivo e registra na tabela 'arquivo'
          const formData = new FormData()
          formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', file.data.path)
          const fileUploadRes = await oikosApi.post('/', formData)

        }))
      }

      notifySuccess('Rascunho salvo com sucesso.')
      props.preloading();

      setAddContractIsLoading(false);
      /*
      setData({});
      setProducts([]);
      setPaymentEvents([]);
      */
      setContratoFile([]);
      setPropostaComercialFile([]);
      setTermoDeReferenciaFile([]);
      setFiles([]);



      handleClose();
    } catch (e) {
      notifyError('Erro ao salvar rascunho: ' + formatApiError(e))
      console.error('handleSaveDraftSubmit error:', e)

      setAddContractIsLoading(false);
    }
  }

  const openProjectAndRegisterRecAndProd = async (insertedContractId) => {

    const formDataAbrirProjeto = new FormData()
    formDataAbrirProjeto.append('acao', 'abrir_projeto')
    formDataAbrirProjeto.append('contrato_id', insertedContractId || data.contrato_id)
    formDataAbrirProjeto.append('proj_nome', data.contrato_nome || '')
    formDataAbrirProjeto.append('proj_cod', data.contrato_num || '')

    const resAbrirProjeto = await powerAppsApi.post('/', formDataAbrirProjeto, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    console.log(resAbrirProjeto)

    const formData = new FormData()
    formData.append('acao', 'cad_prod_rec')

    formData.append('proj_id', resAbrirProjeto.data)

    const res = await powerAppsApi.post('/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    const formDataProjEquipe = new FormData()
    formDataProjEquipe.append('acao', 'cad_projEquipe')
    formDataProjEquipe.append('proj_id', resAbrirProjeto.data)
    formDataProjEquipe.append('prop_id', data.prop_id)

    const resProjEquipe = await powerAppsApi.post('/', formDataProjEquipe, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    /*
    if (this.state.stakeholders.length > 0) {
      for (const stake of this.state.stakeholders) {

        if (stake.novo === 1) {

          const newPfBody = {
            action: 'insert',
            table: 'pf',
            data: {
              pf_emailProf: stake.pf_emailProf,
              pf_nomeExibicao: stake.pf_nomeExibicao,
              pf_celProf: stake.pf_celProf,
              pf_cargo: stake.papel_nome,
              pj_id: openProjectData.contrato_contratante,
            }
          }

          const pfId = await oikosApi.post('/', newPfBody);



          const newStakeholderBody = {
            action: 'insert',
            table: 'projStake',
            data: {
              proj_id: resAbrirProjeto.data,
              pf_id: pfId.data[0].pf_id,
              papel_id: stake.papel_id
            }
          }

          await oikosApi.post('/', newStakeholderBody)


        } else {

          const newStakeholderBody = {
            action: 'insert',
            table: 'projStake',
            data: {
              proj_id: resAbrirProjeto.data,
              pf_id: stake.pf_id,
              papel_id: stake.papel_id,
            }
          }

          await oikosApi.post('/', newStakeholderBody)

        }

      }
    }
    const updateContratoBody = {
      action: 'update',
      table: 'contrato',
      data: {
        contrato_id: data.contrato_id,
      }
    }

    await oikosApi.post('/', updateContratoBody)
    */

    console.log(data)
    if (data.contrato_original) {
      await update('proj', data.proj_id_contrato_original, { projSituacao_id: 0 })
    } else {
      await update('proj', data.proj_id, { projSituacao_id: 0 })
    }

    const resGerenteTecnico = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'pf',
      data: {
        pf_cargo: 'Gerente Técnico',
        pf_ativo: 1,
      },
    })}`);

    if (!resGerenteTecnico.data.length) {
      return notifyError('Gerente Técnico não encontrado. Notificação de abertura do projeto não enviada.')
    }

    const gerenteTecnico = resGerenteTecnico.data[0]

    await sendEmailToNotify(gerenteTecnico.pf_emailProf, `Projeto ${data.contrato_nome} aberto`, `O projeto ${data.contrato_nome} foi aberto. Acesse o sistema para mais detalhes.`)
  }

  if (isLoadingRow) {
    return (
      <Spinner />
    )
  }

  return (
    <>
      {(() => {
        const instLabelLower = String(getInstLabel(data.contratoInst_id)).toLowerCase().trim();
        const isRescisao = props.isAditivoMode && (instLabelLower === 'rescisão' || instLabelLower === 'rescisao');
        const isApostilamento = props.isAditivoMode && instLabelLower === 'apostilamento';
        const isAditamento = props.isAditivoMode && instLabelLower === 'aditamento';
        const hideCronograma = isRescisao || isApostilamento;
        const hideOrcamento = isRescisao || isApostilamento || isAditamento;

        return (
          <>
            {props.isAditivoMode ? (
        <UncontrolledDropdown>
          <DropdownToggle caret color="primary" className="btn-sm">
            {props.buttonText || "Cadastrar Aditivo"}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => {
              handleClickOpen('Aditamento');
            }}>
              Aditamento
            </DropdownItem>
            <DropdownItem onClick={() => {
              handleClickOpen('Apostilamento');
            }}>
              Apostilamento
            </DropdownItem>
            <DropdownItem onClick={() => {
              handleClickOpen('Rescisão');
            }}>
              Rescisão
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      ) : (
        <Btn variant="" onClick={async () => {
          handleClickOpen();
        }}>
          {props.buttonText || "Cadastrar contrato"}
        </Btn>
      )}
      <Dialog
        fullWidth
        maxWidth='md'
        open={open}
        onClose={() => setOpenModalCloseConfirmation(true)}
        PaperProps={{
          style: {
            margin: 'auto', // Ensures the modal aligns well within the screen center
          },
          component: 'form',
          onSubmit: async (event) => {
            setIsStatusLoading(true)
            event.preventDefault();
            setIsStatusLoading(false)
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Tabs>
          <TabList className='pl-5'>
            <Tab>Geral</Tab>
            {!hideCronograma && <Tab>Produtos</Tab>}
            {!hideCronograma && <Tab>Eventos de Pagamento</Tab>}
            <Tab>Anexos</Tab>
            {!hideOrcamento && (
              <li className='react-tabs__tab' role='presentation'>
                <a
                  href={`https://oikos.ecoss.is/oikos-client/comercial/acompanhamento/revisar-orcamento/${data.prop_id}`}
                  target='_blank'
                  rel='noreferrer'
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  Orçamento
                </a>
              </li>
            )}
          </TabList>
          <TabPanel>
            <Row style={{ padding: 20 }}>
              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <div className="d-flex align-items-center" style={{ marginBottom: -4 }}>
                    <Label>
                      Nº Contrato
                    </Label>
                    <FormInputTooltip
                      text="Na ausência de Contrato preencher com o nº da proposta, nº da OS ou nº do edital."
                    />
                  </div>
                  <Input
                    invalid={data.contrato_num_Invalid}
                    value={data.contrato_num}
                    onChange={e => setData({
                      ...data,
                      contrato_num: e.target.value || null,
                      contrato_num_Invalid: false,
                    }
                    )}
                  />
                  <FormFeedback>Campo obrigatório.</FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Data da proposta
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={
                      data.contrato_dtProp
                        ? moment(data.contrato_dtProp).toDate()
                        : null
                    }
                    onChange={date => setData(
                      {
                        ...data,
                        contrato_dtProp: date,
                        contrato_dtProp_Invalid: false,
                      }
                    )}
                  />
                  <FormFeedback invalid={data.contrato_dtProp_Invalid}>
                    Campo obrigatório.
                  </FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Alteração contratual
                  </Label>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    isDisabled={props.isAditivoMode}
                    isLoading={false}
                    isSearchable={true}
                    value={selContratoInst && selContratoInst?.filter(x => (String(x.value) === String(data.contratoInst_id)))}
                    options={props.isAditivoMode ? selContratoInst?.filter(opt => [2, 3, 5].includes(Number(opt.value))) : (selContratoInst || [])}
                    onChange={e => {
                      const isApost = String(e.label).toLowerCase().trim() === 'apostilamento';
                      let apostTpId = null;
                      if (isApost) {
                        apostTpId = selContratoAlterTp?.find(opt => String(opt.label).toLowerCase().trim() === 'reajuste de preço')?.value;
                      }
                      setData({
                        ...data,
                        contratoInst_id: e.value,
                        contratoInst_id_Invalid: false,
                        contratoAlterTp_id: apostTpId || null,
                        ...(e.value === 1 ? { contrato_original: undefined } : {})
                      });
                    }}
                  />

                  <FormFeedback invalid={props.data.contratoInst_id_Invalid}>
                    Campo obrigatório.
                  </FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Área de atuação
                  </Label>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    isDisabled={false}
                    isLoading={false}

                    isSearchable={true}
                    value={selAreaAtua && selAreaAtua?.filter(x => (x.value === data.areaAtua_id))}
                    options={selAreaAtua || []}
                    onChange={e => setData({
                      ...data,
                      areaAtua_id: e.value,
                    }
                    )}
                  />
                </FormGroup>
              </Col>

              {props.isAditivoMode && !isRescisao && !isApostilamento &&
                <Col sm={4}>
                  <FormGroup>
                    <Label>
                      Motivo da Alteração <span style={{ color: 'red' }}>*</span>
                    </Label>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      isDisabled={false}
                      isLoading={false}
                      isSearchable={true}
                      value={selContratoAlterTp && selContratoAlterTp?.filter(x => (String(x.value) === String(data.contratoAlterTp_id)))}
                      options={getOptionsMotivo() || []}
                      onChange={e => setData({
                        ...data,
                        contratoAlterTp_id: e.value,
                        contratoAlterTp_id_Invalid: false,
                      }
                      )}
                    />
                    <FormFeedback invalid={data.contratoAlterTp_id_Invalid}>
                      Campo obrigatório.
                    </FormFeedback>
                  </FormGroup>
                </Col>
              }

              {props.isAditivoMode && (String(getInstLabel(data.contratoInst_id)).toLowerCase().trim() === 'rescisão' || String(getInstLabel(data.contratoInst_id)).toLowerCase().trim() === 'rescisao') && (
                <>
                  <Col sm={4}>
                    <FormGroup>
                      <Label>
                        Data da notificação
                      </Label>
                      <DatePicker
                        placeholderText="__/__/_____"
                        locale="pt-BR"
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={data.contrato_dtNotificacao ? moment(data.contrato_dtNotificacao).toDate() : null}
                        onChange={date => setData(
                          {
                            ...data,
                            contrato_dtNotificacao: date,
                            contrato_dtNotificacao_Invalid: false,
                          },
                        )}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={4}>
                    <FormGroup>
                      <Label>
                        Data da rescisão
                      </Label>
                      <DatePicker
                        placeholderText="__/__/_____"
                        locale="pt-BR"
                        className="form-control"
                        dateFormat="dd/MM/yyyy"
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        selected={data.contrato_dtRescisao ? moment(data.contrato_dtRescisao).toDate() : null}
                        onChange={date => setData(
                          {
                            ...data,
                            contrato_dtRescisao: date,
                            contrato_dtRescisao_Invalid: false,
                          },
                        )}
                      />
                    </FormGroup>
                  </Col>
                </>
              )}

              {(!props.isAditivoMode && data.contratoInst_id != 1) &&
                <Col sm={8}>
                  <FormGroup>
                    <Label>
                      Contrato original
                    </Label>
                    <SearchableSelect
                      classNamePrefix="select2-selection"
                      placeholder="Selecionar..."
                      isDisabled={false}
                      isLoading={false}

                      isSearchable={true}
                      value={selContrato && selContrato?.filter(x => (x.value === data.contrato_original))}
                      options={selContrato.filter(contrato => (contrato.contrato_contratante === data.contrato_contratante && !contrato.contrato_original)) || []}
                      onChange={e => {
                        setData({
                          ...data,
                          contrato_original: e?.value,
                          contrato_original_Invalid: false,
                        }
                        )
                      }}
                    />
                    <FormFeedback invalid={props.data.contrato_original_Invalid}>
                      Campo obrigatório.
                    </FormFeedback>
                  </FormGroup>
                </Col>
              }

              {!props.isAditivoMode && (
                <>
                  <Col sm={6}>
                    <FormGroup>
                      <Label>
                        Contratante
                      </Label>

                      <SearchableSelect
                        classNamePrefix="select2-selection"
                        placeholder="Selecionar..."
                        isDisabled={false}
                        isLoading={false}

                        isSearchable={true}
                        options={selContratante}
                        value={selContratante && selContratante?.filter(x => (x.value === data.contrato_contratante))}
                        onChange={e => setData({
                          ...data,
                          contrato_contratante: e?.value
                        }
                        )}
                      />
                    </FormGroup>
                  </Col>

                  <Col sm={6}>
                    <FormGroup>
                      <Label>
                        Contratada
                      </Label>
                      <SearchableSelect
                        classNamePrefix="select2-selection"
                        placeholder="Selecionar..."
                        isDisabled={false}
                        isLoading={false}

                        isSearchable={true}
                        options={selContratada}
                        value={selContratada && selContratada?.filter(x => (x.value === data.contrato_contratada))}
                        onChange={e => setData({
                          ...data,
                          contrato_contratada: e?.value
                        })}
                      />
                    </FormGroup>
                  </Col>
                </>
              )}

              {!(props.isAditivoMode && (String(getInstLabel(data.contratoInst_id)).toLowerCase().trim() === 'rescisão' || String(getInstLabel(data.contratoInst_id)).toLowerCase().trim() === 'rescisao')) && (
                <Col sm={12}>
                  <FormGroup>
                    <div className="d-flex align-items-center" style={{ marginBottom: -4 }}>
                      <Label>
                        {isApostilamento ? 'Objeto do apostilamento' : isAditamento ? 'Objeto do aditamento' : 'Objeto do contrato'}
                      </Label>
                      <FormInputTooltip
                        text="Objeto tal e qual está no contrato ou descrição sumária."
                      />
                    </div>
                    <Input
                      invalid={data.contrato_obj_Invalid}
                      type="textarea"
                      rows={2}
                      value={data.contrato_obj}
                      onChange={e => setData(
                        {
                          ...data,
                          contrato_obj: e.target.value || null,
                          contrato_obj_Invalid: false,
                        },
                      )}
                    />
                    <FormFeedback>Campo obrigatório.</FormFeedback>
                  </FormGroup>
                </Col>
              )}

              {/*
              <Col sm={12}>
                <Button
                  size="sm"
                  color="link"
                  className="mb-1 px-0"
                  onClick={() => {
                    setStakeholders([...stakeholders, {}])
                  }}
                >
                  Adicionar Stakeholder
                </Button>
              </Col>
              {stakeholders.length > 0 &&
                stakeholders.map((stake, index) => {
                  return (
                    <>
                      <Col sm={12}>
                        <FormGroup>
                          <Label>
                            Alteração contratual
                          </Label>
                          <SearchableSelect
                            classNamePrefix="select2-selection"
                            placeholder="Selecionar..."
                            isDisabled={false}
                            isLoading={false}

                            isSearchable={true}
                            value={pfs && pfs?.filter(x => (x.value === data.contratoInst_id))}
                            options={selContratoInst || []}
                            onChange={e => {
                              setData({
                                ...data,
                                contratoInst_id: e.value,
                                contratoInst_id_Invalid: false,
                                ...(e.value === 1 ? { contrato_original: undefined } : {})
                              });
                            }}
                          />

                          <FormFeedback invalid={props.data.contratoInst_id_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                      <Row>
                        <Col sm={3}>
                          <FormGroup>
                            <Label>
                              Nome
                            </Label>
                            <Input
                              type="text"
                              rows={2}
                              value={stake.pf_nomeExibicao}
                              onChange={e => {
                                stakeholders[index] = {...stakeholders[index], pf_nomeExibicao: e.target.value}
                              }}
                            />
                            <FormFeedback>Campo obrigatório.</FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col sm={3}>
                          <FormGroup>
                            <Label>
                              Email
                            </Label>
                            <Input
                              type="text"
                              rows={2}
                              value={stake.pf_emailProf}
                              onChange={e => {
                                stakeholders[index] = {...stakeholders[index], pf_emailProf: e.target.value}
                              }}
                            />
                            <FormFeedback>Campo obrigatório.</FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col sm={3}>
                          <FormGroup>
                            <Label>
                              Telefone
                            </Label>
                            <Input
                              type="text"
                              rows={2}
                              value={stake.pf_celProf}
                              onChange={e => {
                                stakeholders[index] = {...stakeholders[index], pf_celProf: e.target.value}
                              }}
                            />
                            <FormFeedback>Campo obrigatório.</FormFeedback>
                          </FormGroup>
                        </Col>
                        <Col sm={3}>
                          <FormGroup>
                            <Label>
                              Cargo
                            </Label>
                            <Input
                              type="text"
                              rows={2}
                              value={stake.pf_cargo}
                              onChange={e => {
                                stakeholders[index] = {...stakeholders[index], pf_cargo: e.target.value}
                              }}
                            />
                            <FormFeedback>Campo obrigatório.</FormFeedback>
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )
                })
              }
              <button onClick={(e)=>{e.preventDefault(); console.log(stakeholders)}}>stake</button>
              */}

              <Col sm={4}>
                <FormGroup>
                  <Label>
                    Data da assinatura
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={data.contrato_dtAssin ? moment(data.contrato_dtAssin).toDate() : null}
                    onChange={date => setData(
                      {
                        ...data,
                        contrato_dtAssin: date,
                        contrato_dtAssin_Invalid: false,
                      },
                    )}
                  />
                  <FormFeedback invalid={data.contrato_dtAssin_Invalid}>
                    Campo obrigatório.
                  </FormFeedback>
                </FormGroup>
              </Col>

              {props.isAditivoMode && !isRescisao && (
                <Col sm={4}>
                  <FormGroup>
                    <Label>
                      Data de início de vigência
                    </Label>
                    <DatePicker
                      placeholderText="__/__/_____"
                      locale="pt-BR"
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      peekNextMonth
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      selected={data.contrato_dtIniVig ? moment(data.contrato_dtIniVig).toDate() : null}
                      onChange={date => setData(
                        {
                          ...data,
                          contrato_dtIniVig: date,
                          contrato_dtIniVig_Invalid: false,
                        },
                      )}
                    />
                    <FormFeedback invalid={data.contrato_dtIniVig_Invalid}>
                      Campo obrigatório.
                    </FormFeedback>
                  </FormGroup>
                </Col>
              )}

              <Col sm={4} style={{ display: checkVisible('contrato_prazoVigencia') ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Fim do prazo de vigência
                  </Label>
                  {isAditamento && (
                    <div className="mb-2">
                      <CustomInput
                        type="radio"
                        id="prazoAcrescimo"
                        label="Acréscimo"
                        inline
                        checked={data.aditamento_prazo_sinal === 'acrescimo' || !data.aditamento_prazo_sinal}
                        onChange={() => setData({ ...data, aditamento_prazo_sinal: 'acrescimo' })}
                      />
                      <CustomInput
                        type="radio"
                        id="prazoSupressao"
                        label="Supressão"
                        inline
                        checked={data.aditamento_prazo_sinal === 'supressao'}
                        onChange={() => setData({ ...data, aditamento_prazo_sinal: 'supressao' })}
                      />
                    </div>
                  )}
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={data.contrato_prazoVigencia ? moment(data.contrato_prazoVigencia).toDate() : null}
                    onChange={date => setData(
                      {
                        ...data,
                        contrato_prazoVigencia: date,
                        contrato_prazoVigencia_Invalid: false,
                      },
                    )}
                  />
                  <FormFeedback invalid={data.contrato_prazoVigencia_Invalid}>
                    Campo obrigatório.
                  </FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: checkVisible('contrato_prazoExecucao') ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Fim do prazo de execução
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={data.contrato_prazoExecucao ? moment(data.contrato_prazoExecucao).toDate() : null}
                    onChange={date => {
                      if (date) {
                        setData(
                          {
                            ...data,
                            contrato_prazoExecucao: date,
                            contrato_prazoExecucao_Invalid: false,
                          }
                        )
                      }
                    }}
                  />
                  <FormFeedback invalid={data.contrato_prazoExecucao_Invalid}>
                    Campo obrigatório.
                  </FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: checkVisible('valorGlobal') ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    {isApostilamento ? 'Valor adicionado' : isAditamento ? 'Valor adicionado/suprimido' : 'Valor global'}
                  </Label>
                  {isAditamento && (
                    <div className="mb-2">
                      <CustomInput
                        type="radio"
                        id="valorAcrescimo"
                        label="Acréscimo"
                        inline
                        checked={data.aditamento_valor_sinal === 'acrescimo' || !data.aditamento_valor_sinal}
                        onChange={() => setData({ ...data, aditamento_valor_sinal: 'acrescimo' })}
                      />
                      <CustomInput
                        type="radio"
                        id="valorSupressao"
                        label="Supressão"
                        inline
                        checked={data.aditamento_valor_sinal === 'supressao'}
                        onChange={() => setData({ ...data, aditamento_valor_sinal: 'supressao' })}
                      />
                    </div>
                  )}
                  <MaskedInput
                    mask="R$ num"
                    unmask
                    inputRef={el => { const inputVlrGlobal = el }}
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 1000000000,
                      },
                    }}
                    lazy={false}
                    value={valorGlobal}
                    onAccept={value => {
                      setValorGlobal(value);
                    }}
                  />
                </FormGroup>
              </Col>

              {isApostilamento && (
                <>

                  <Col sm={4}>
                    <FormGroup>
                      <Label>Fator de reajuste (%) <span style={{ color: 'red' }}>*</span></Label>
                      <Input
                        type="number"
                        step="0.01"
                        value={data.contrato_fatorReaj || ''}
                        onChange={e => setData({ ...data, contrato_fatorReaj: e.target.value })}
                      />
                    </FormGroup>
                  </Col>
                </>
              )}

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Fiança
                  </Label>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    isDisabled={false}
                    isLoading={false}

                    isSearchable={true}
                    options={YES_OR_NOT}
                    value={YES_OR_NOT.filter(t => t.value === (data?.contrato_fianca ? data.contrato_fianca : null))}
                    onChange={e =>
                      setData({
                        ...data,
                        contrato_fianca: e?.value,
                        contrato_fianca_Invalid: false,
                        contrato_dtLimFianca: null,
                        contrato_dtLimFianca_Invalid: false,
                      })
                    }
                  />
                  <FormFeedback invalid={data.contrato_fianca_Invalid}>
                    Campo obrigatório.
                  </FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Data limite da fiança
                  </Label>
                  <DatePicker
                    disabled={
                      !data.contrato_fianca
                      || data.contrato_fianca === '0'
                    }
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={data.contrato_dtLimFianca ? moment(data.contrato_dtLimFianca).toDate() : null}
                    onChange={date => {
                      date ? setData({ ...data, contrato_dtLimFianca: date })
                        : setData({ ...data, contrato_dtLimFianca: null })
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: checkVisible('contrato_indReaj_id') ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Índice de reajuste
                  </Label>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    isDisabled={false}
                    isLoading={false}
                    isSearchable={true}
                    value={
                      (selIndReaj && selIndReaj.find(x => String(x.value) === String(data.contrato_indReaj_id))) 
                      || 
                      (data.contrato_indiceReaj_defasado && !data.contrato_indReaj_id ? { value: '', label: `${data.contrato_indiceReaj_defasado} (Defasado)` } : null)
                    }
                    options={selIndReaj || []}
                    onChange={e => setData({
                      ...data,
                      contrato_indReaj_id: e ? e.value : null,
                    })}
                  />
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: checkVisible('contrato_dtBaseReaj') ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    {isApostilamento ? 'Data de apostilamento' : 'Data base do reajuste'}
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={data.contrato_dtBaseReaj ? moment(data.contrato_dtBaseReaj).toDate() : null}
                    onChange={date => date ? setData({ ...data, contrato_dtBaseReaj: date }) : setData({ ...data, contrato_dtBaseReaj: null })}
                  />
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Data de aniv. do reajuste
                  </Label>
                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={data.contrato_dtAnivReaj ? moment(data.contrato_dtAnivReaj).toDate() : null}
                    onChange={date => date ? setData({ ...data, contrato_dtAnivReaj: date }) : setData({ ...data, contrato_dtAnivReaj: null })}
                  />
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Possibilidade de aditivo?
                  </Label>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    isDisabled={false}
                    isLoading={false}

                    isSearchable={true}
                    options={YES_OR_NOT}
                    value={YES_OR_NOT.filter(t => t.value === (data?.contrato_permiteRenovacao ? data.contrato_permiteRenovacao : null))}
                    onChange={e => setData(
                      {
                        ...data,
                        contrato_permiteRenovacao: e?.value,
                      }
                    )}
                  />

                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Haverá emissão de OS?
                  </Label>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    isDisabled={false}
                    isLoading={false}

                    isSearchable={true}
                    options={YES_OR_NOT}
                    value={YES_OR_NOT.filter(t => t.value === (data?.contrato_aguardarOS ? data.contrato_aguardarOS : null))}
                    onChange={e => setData(
                      {
                        ...data,
                        contrato_aguardarOS: e?.value,
                      }
                    )}

                  />
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Informações de pagamento
                  </Label>
                  <Input
                    invalid={data.contrato_infoPgto_Invalid}
                    value={data.contrato_infoPgto}
                    onChange={e => setData(
                      {
                        ...data,
                        contrato_infoPgto: e.target.value || null,
                        contrato_infoPgto_Invalid: false,
                      },
                    )}
                  />
                  <FormFeedback>Campo obrigatório.</FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Código Tributário
                  </Label>
                  <Input
                    value={data.contrato_codTrib}
                    onChange={e => setData(
                      {
                        ...data,
                        contrato_codTrib: e.target.value || null,
                      },
                    )}
                  />
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Alíquota de ISSQN
                  </Label>
                  <MaskedInput
                    mask="num"
                    unmask
                    inputRef={el => { const inputVlrGlobal = el }}
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 5,
                      },
                    }}
                    lazy={false}
                    value={String(data.contrato_aliqISS)}
                    onAccept={value => {
                      setData({
                        ...data,
                        contrato_aliqISS: value,
                      });
                    }}
                  />
                </FormGroup>
              </Col>

              <Col sm={4} style={{ display: !props.isAditivoMode ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Município de Recolhimento do ISS
                  </Label>
                  <SearchableSelect
                    classNamePrefix="select2-selection"
                    placeholder="Selecionar..."
                    isDisabled={false}
                    isLoading={false}

                    isSearchable={true}
                    value={selMun && selMun?.filter(x => (x.value === data.contrato_munISS))}
                    options={selMun || []}
                    onChange={e => setData({
                      ...data,
                      contrato_munISS: e?.value,
                      contrato_munISS_Invalid: false,
                    })}
                  />
                  <FormFeedback invalid={props.data.contrato_fianca_Invalid}>
                    Campo obrigatório.
                  </FormFeedback>
                </FormGroup>
              </Col>

              <Col sm={12} style={{ display: checkVisible('contrato_obs') ? 'block' : 'none' }}>
                <FormGroup>
                  <Label>
                    Observações gerais
                  </Label>
                  <Input
                    type="textarea"
                    rows={2}
                    value={data.contrato_obs}
                    onChange={e => setData(
                      {
                        ...data,
                        contrato_obs: e.target.value || null,
                      },
                    )}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Col>
              <FormGroup>
                <Label className="font-weight-bold">
                  {isRescisao ? 'Anexo' : isApostilamento ? 'Apostilamento' : isAditamento ? 'Aditamento' : 'Contrato'}
                </Label>
                {
                  linkContratoFile.length > 0 &&
                  linkContratoFile.map(
                    (link, index) => (
                      <>
                        <Button
                          onClick={(e) => { e.preventDefault(); window.open(`https://oikos.ecoss.is/oikos/${link}`, '_blank'); }}
                          title="Comprovante"
                          className="ml-2"
                          color="light"
                          size="sm"
                        >
                          <i className="ri-folder-2-line" />
                        </Button>
                        <br />
                      </>
                    )
                  )
                }
                {
                  linkContratoFile.length <= 0 &&
                  <AddFilesNoForm
                    multiple={false}
                    accept={['.pdf']}
                    files={contratoFile} // Pass state
                    onFilesChange={setContratoFile} // Update state
                  />
                }
              </FormGroup>
            </Col>

            {!(isRescisao || isApostilamento || isAditamento) && (
              <>
                <Col>
                  <FormGroup>
                    <Label className="font-weight-bold">
                      Proposta comercial
                    </Label>
                    {
                      linkPropostaComercialFile.length > 0 &&
                      linkPropostaComercialFile.map(
                        (link, index) => (
                          <>
                            <Button
                              onClick={(e) => { e.preventDefault(); window.open(`https://oikos.ecoss.is/oikos/${link}`, '_blank'); }}
                              title="Comprovante"
                              className="ml-2"
                              color="light"
                              size="sm"
                            >
                              <i className="ri-folder-2-line" />
                            </Button>
                            <br />
                          </>
                        )
                      )
                    }
                    {
                      linkPropostaComercialFile.length <= 0 &&
                      <AddFilesNoForm
                        multiple={false}
                        accept={['.pdf']}
                        files={propostaComercialFile} // Pass state
                        onFilesChange={setPropostaComercialFile} // Update state
                      />
                    }
                  </FormGroup>
                </Col>

                <Col>
                  <FormGroup>
                    <Label className="font-weight-bold">
                      Termo de Referência
                    </Label>
                    {
                      linkTermoDeReferenciaFile.length > 0 &&
                      linkTermoDeReferenciaFile.map(
                        (link, index) => (
                          <>
                            <Button
                              onClick={(e) => { e.preventDefault(); window.open(`https://oikos.ecoss.is/oikos/${link}`, '_blank'); }}
                              title="Comprovante"
                              className="ml-2"
                              color="light"
                              size="sm"
                            >
                              <i className="ri-folder-2-line" />
                            </Button>
                            <br />
                          </>
                        )
                      )
                    }
                    {
                      linkTermoDeReferenciaFile.length <= 0 &&
                      <AddFilesNoForm
                        multiple={false}
                        accept={['.pdf']}
                        files={termoDeReferenciaFile} // Pass state
                        onFilesChange={setTermoDeReferenciaFile} // Update state
                      />
                    }
                  </FormGroup>
                </Col>
              </>
            )}
          </TabPanel>
          {!hideCronograma && (
            <TabPanel>
            <Row style={{ padding: 20 }}>
              <Col>
                <Label>
                  Produtos
                </Label>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button
                  size="sm"
                  color="link"
                  className="mb-1 px-0"
                  onClick={handleAddProductInline}
                >
                  Adicionar via formulário
                </Button>
              </Col>
            </Row>

            {(() => {
              const existingProducts = props.isAditivoMode
                ? (products || []).filter(p => p.origin === 'existing')
                : (products || [])
              const newProducts = props.isAditivoMode
                ? (products || []).filter(p => p.origin !== 'existing')
                : []

              const renderProductRows = (list, emptyLabel) => (
                <div className="table-responsive mb-3">
                  <Table striped bordered>
                    <thead>
                      <tr>
                        <th style={{ width: 70 }}>Ordem</th>
                        <th>Descrição</th>
                        <th style={{ width: 160 }}>Prazo (dias)</th>
                        <th style={{ width: 100 }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length > 0 ? list.map((product) => {
                        const index = products.findIndex(p =>
                          (product.tempId && p.tempId === product.tempId)
                          || (product.contratoProd_id && p.contratoProd_id === product.contratoProd_id)
                        )
                        const rowKey = product.tempId || product.contratoProd_id || index
                        return (
                          <tr key={rowKey}>
                            <td>{index + 1}</td>
                            <td>
                              <Input
                                value={product.contratoProd_desc || ''}
                                onChange={(e) => updateProductByTempId(product.tempId || product.contratoProd_id, 'contratoProd_desc', e.target.value)}
                                placeholder="Descrição do produto"
                              />
                            </td>
                            <td>
                              <Input
                                type="number"
                                min={0}
                                value={product.contratoProd_prazo ?? ''}
                                onChange={(e) => {
                                  const value = e.target.value
                                  updateProductByTempId(
                                    product.tempId || product.contratoProd_id,
                                    'contratoProd_prazo',
                                    value === '' ? '' : Number(value),
                                  )
                                }}
                                onWheel={(e) => e.target.blur()}
                                placeholder="Dias"
                              />
                            </td>
                            <td>
                              <Button
                                title="Excluir"
                                color="light"
                                size="sm"
                                onMouseOver={() => setDeleteProductData({ ...product, index })}
                                onClick={() => handleDeleteProduct(index)}
                              >
                                <i className="ri-delete-bin-6-line" />
                              </Button>
                            </td>
                          </tr>
                        )
                      }) : (
                        <tr>
                          <td colSpan={4} className="text-muted">{emptyLabel}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )

              if (!props.isAditivoMode) {
                return (
                  <Row style={{ padding: 20 }}>
                    <Col>
                      {renderProductRows(existingProducts, 'Nenhum produto cadastrado.')}
                    </Col>
                  </Row>
                )
              }

              return (
                <Row style={{ padding: 20 }}>
                  <Col>
                    <Label className="font-weight-bold">Existentes (do contrato original)</Label>
                    <p className="text-muted" style={{ fontSize: 12 }}>
                      Edite ou exclua. Excluir desativa o registro no contrato original (ativo = 0). Itens existentes não são duplicados no aditivo.
                    </p>
                    {renderProductRows(existingProducts, 'Nenhum produto existente no contrato original.')}

                    <Label className="font-weight-bold mt-3">Novos (inclusões deste aditivo)</Label>
                    {renderProductRows(newProducts, 'Nenhum produto novo. Use “Adicionar via formulário”.')}
                  </Col>
                </Row>
              )
            })()}
          </TabPanel>
          )}
          {!hideCronograma && (
            <TabPanel>
            <Row style={{ padding: 20 }}>
              <Col>
                <Label>
                  Eventos de Pagamento
                </Label>
              </Col>

              <Col className="d-flex justify-content-end">
                <Button
                  size="sm"
                  color="link"
                  className="mb-1 px-0"
                  onClick={handleAddPaymentInline}
                >
                  Adicionar via formulário
                </Button>
              </Col>
            </Row>

            {(() => {
              const existingEvents = props.isAditivoMode
                ? (paymentEvents || []).filter(p => p.origin === 'existing')
                : (paymentEvents || [])
              const newEvents = props.isAditivoMode
                ? (paymentEvents || []).filter(p => p.origin !== 'existing')
                : []

              const renderPaymentRows = (list, emptyLabel, showFooter) => (
                <div className="table-responsive mb-3">
                  <Table striped bordered>
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th style={{ width: 180 }}>Valor do EP</th>
                        <th style={{ width: 140 }}>Prazo (dias)</th>
                        <th style={{ width: 100 }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length > 0 ? list.map((payment) => {
                        const index = paymentEvents.findIndex(p =>
                          (payment.tempId && p.tempId === payment.tempId)
                          || (payment.contratoEP_id && p.contratoEP_id === payment.contratoEP_id)
                        )
                        let productLinkedToPayment = {}
                        if (payment.contratoEP_id) {
                          productLinkedToPayment = products.find(p => p.contratoEP_id === payment.contratoEP_id) || {}
                        } else if (payment.productId) {
                          productLinkedToPayment = products.find(p => p.tempId === payment.productId) || {}
                        }

                        const recTpVal = payment.recTp_id?.recTp_id ?? payment.recTp_id
                        const descValue = productLinkedToPayment && Object.keys(productLinkedToPayment).length > 0 && recTpVal !== 6
                          ? (productLinkedToPayment.contratoProd_desc || '')
                          : (payment.contratoEP_desc || '')

                        return (
                          <tr key={payment.tempId || payment.contratoEP_id || index}>
                            <td>
                              <Input
                                value={descValue}
                                onChange={(e) => {
                                  const value = e.target.value
                                  if (productLinkedToPayment && Object.keys(productLinkedToPayment).length > 0 && recTpVal !== 6) {
                                    updateProductByTempId(productLinkedToPayment.tempId || productLinkedToPayment.contratoProd_id, 'contratoProd_desc', value)
                                  }
                                  updatePaymentByTempId(payment.tempId || payment.contratoEP_id, 'contratoEP_desc', value)
                                }}
                                placeholder="Descrição do evento"
                              />
                            </td>
                            <td>
                              <Input
                                type="number"
                                min={0}
                                step="0.01"
                                value={payment.contratoEP_vlr ?? ''}
                                onChange={(e) => {
                                  const value = e.target.value
                                  updatePaymentByTempId(
                                    payment.tempId || payment.contratoEP_id,
                                    'contratoEP_vlr',
                                    value === '' ? '' : Number(value),
                                  )
                                }}
                                onWheel={(e) => e.target.blur()}
                                placeholder="Valor"
                              />
                            </td>
                            <td>
                              <Input
                                type="number"
                                min={0}
                                value={payment.contratoEP_prazo ?? ''}
                                onChange={(e) => {
                                  const value = e.target.value
                                  updatePaymentByTempId(
                                    payment.tempId || payment.contratoEP_id,
                                    'contratoEP_prazo',
                                    value === '' ? '' : Number(value),
                                  )
                                }}
                                onWheel={(e) => e.target.blur()}
                                placeholder="Dias"
                              />
                            </td>
                            <td>
                              <Button
                                title="Excluir"
                                color="light"
                                size="sm"
                                onClick={() => { setDeletePaymentData({ ...payment, index }); setOpenModalConfirmEPDelete(true); }}
                              >
                                <i className="ri-delete-bin-6-line" />
                              </Button>
                            </td>
                          </tr>
                        )
                      }) : (
                        <tr>
                          <td colSpan={4} className="text-muted">{emptyLabel}</td>
                        </tr>
                      )}
                    </tbody>
                    {showFooter && (
                      <tfoot>
                        <tr>
                          <td>Total</td>
                          <td>
                            {
                              paymentEvents.length > 0 &&
                              currencyFormatter
                                .format(paymentEvents
                                  .map(pe => pe.contratoEP_vlr)
                                  .reduce((total, current) => Number(total) + Number(current), 0))
                            }
                          </td>
                          <td />
                          <td />
                        </tr>
                        <tr>
                          <td>Saldo remanescente</td>
                          <td style={{
                            color: paymentEvents.length > 0 ? ((Number(valorGlobal) - paymentEvents
                              .map(pe => pe.contratoEP_vlr)
                              .reduce((total, current) => Number(total) + Number(current), 0)) < 0 && 'red') : ''
                          }}>
                            {
                              paymentEvents.length > 0 &&
                              currencyFormatter
                                .format(Number(valorGlobal) - paymentEvents
                                  .map(pe => pe.contratoEP_vlr)
                                  .reduce((total, current) => Number(total) + Number(current), 0))
                            }
                          </td>
                          <td />
                          <td />
                        </tr>
                      </tfoot>
                    )}
                  </Table>
                </div>
              )

              if (!props.isAditivoMode) {
                return (
                  <Row style={{ padding: 20 }}>
                    <Col>
                      {renderPaymentRows(existingEvents, 'Nenhum evento de pagamento cadastrado.', true)}
                    </Col>
                  </Row>
                )
              }

              return (
                <Row style={{ padding: 20 }}>
                  <Col>
                    <Label className="font-weight-bold">Existentes (do contrato original)</Label>
                    <p className="text-muted" style={{ fontSize: 12 }}>
                      Edite ou exclua. Excluir desativa o registro no contrato original (ativo = 0). Itens existentes não são duplicados no aditivo.
                    </p>
                    {renderPaymentRows(existingEvents, 'Nenhum evento existente no contrato original.', false)}

                    <Label className="font-weight-bold mt-3">Novos (inclusões deste aditivo)</Label>
                    {renderPaymentRows(newEvents, 'Nenhum evento novo. Use “Adicionar via formulário”.', true)}
                  </Col>
                </Row>
              )
            })()}
          </TabPanel>
          )}
          <TabPanel>
            <AddFiles
              multiple={false}
              //accept={['.pdf']}
              files={files} // Pass state
              onFilesChange={setFiles} // Update state
            />
          </TabPanel>
        </Tabs>
        <DialogActions>
          {addContractIsLoading && (
            <Btn
              autoFocus
              margin="dense"
              id="entregaRevInterna"
              name="entrega_rev_interna"
              label="Entrega a Revisao Interna"
              type="submit"
              variant="outlined"
              disabled
              endIcon={<Spinner />}
            >Aguarde</Btn>
          )}

          {!addContractIsLoading && (
            <div className="d-flex justify-content-start mb-3">
              {/* <Btn
                  className='text-warning'
                  type='submit'
                  onClick={async (e) => {
                    e.preventDefault();

                    await handleSaveContractSubmit();
                  }}
                >
                  Salvar como rascunho
                </Btn> */}
              <Btn
                className='text-success'
                type='submit'
                onClick={async (e) => {
                  e.preventDefault();

                  await handleAddContractSubmit();
                }}
              >
                Salvar e enviar
              </Btn>
              <Btn
                onClick={async (e) => {
                  e.preventDefault();
                  setOpenModalCloseConfirmation(true);
                }}
              >
                Cancelar
              </Btn>
            </div>
          )}
        </DialogActions>
      </Dialog>
      <Modal
        open={openAddProductModal}
        onClose={() => setOpenAddProductModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Adicionar produto
          </Typography>
          <FormGroup>
            <Label>
              Descrição
            </Label>
            <Input
              defaultValue={addProductData?.contratoProd_desc}
              onChange={e => {
                setAddProductData({ ...addProductData, contratoProd_desc: e.target.value })
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Prazo de entrega
            </Label>
            <RadioGroup
              row
              defaultValue={true}
              name="radio-buttons-group"
              onChange={(e) => {
                setAddProductData({ ...addProductData, contratoProd_prazo: e.target.value || null })
              }} // Parse to boolean
            >
              <FormControlLabel
                control={<Radio value="30 dias" />}
                label="30 dias"
                checked={addProductData.contratoProd_prazo === '30 dias'}
              />
              <FormControlLabel
                control={<Radio value="45 dias" />}
                label="45 dias"
                checked={addProductData.contratoProd_prazo === '45 dias'}
              />
              <FormControlLabel
                control={<Radio value="60 dias" />}
                label="60 dias"
                checked={addProductData.contratoProd_prazo === '60 dias'}
              />
            </RadioGroup>
            <Input
              defaultValue={addProductData?.contratoProd_prazo}
              value={addProductData?.contratoProd_prazo}
              onChange={e => {
                setAddProductData({ ...addProductData, contratoProd_prazo: e.target.value || null })
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Data de entrega prevista
            </Label>

            <DatePicker
              placeholderText="__/__/_____"
              locale="pt-BR"
              className="form-control"
              dateFormat="dd/MM/yyyy"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={toDateOrNull(addProductData?.contratoProd_dtPrev)}
              onChange={date => date ? setAddProductData({ ...addProductData, contratoProd_dtPrev: date, contratoProd_dtPrev_Invalid: false }) : setAddProductData({ ...addProductData, contratoProd_dtPrev: null, contratoProd_dtPrev_Invalid: true })}
            />
          </FormGroup>

          <Row>
            <Col>
              <hr />
            </Col>
          </Row>

          <Row className="mb-2 mt-2">
            <Col>
              <Label>
                Possui evento de pagamento
              </Label>
            </Col>

            <Col className="d-flex justify-content-end">
              <CustomInput
                type="switch"
                id="hasPaymentEvent"
                onChange={e => {
                  setAddProductData({ ...addProductData, hasPaymentEvent: e?.target?.checked });
                }}
              />
            </Col>
          </Row>

          {(addProductData.hasPaymentEvent) && (
            <>
              <FormGroup>
                <Label>
                  Valor
                </Label>
                <MaskedInput
                  unmask
                  mask="R$ num"
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      min: 0,
                      max: 1000000000 //(valorGlobal - paymentEvents.reduce((ac, current)=> ac + Number(current.contratoEP_vlr), 0)),
                    },
                  }}
                  lazy={false}
                  value={String(addProductData.contratoEP_vlr)}
                  onAccept={value => {

                    setAddProductData({ ...addProductData, contratoEP_vlr: value });
                  }}
                />
              </FormGroup>

              {/*
              <FormGroup>
                <Label>
                  Porcentagem
                </Label>
                <MaskedInput
                  unmask
                  mask="num %"
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      max: (100 - (100*(paymentEvents.filter(pe=>pe.tempId !== addProductData.tempId).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))/valorGlobal)),
                    },
                  }}
                  lazy={false}
                  value={String(100*(addProductData.contratoEP_vlr)/valorGlobal)}
                  onAccept={value => {
                    setAddProductData({...addProductData, contratoEP_vlr: valorGlobal*(Number(value)/100)});
                  }}
                />
              </FormGroup>
              */}

              <FormGroup>
                <Label>
                  Prazo de pagamento
                </Label>
                <Input
                  value={addProductData?.contratoEP_prazo}
                  onChange={e => {
                    setAddProductData({ ...addProductData, contratoEP_prazo: e.target.value || null });
                  }}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Data de pagamento prevista
                </Label>

                <DatePicker
                  placeholderText="__/__/_____"
                  locale="pt-BR"
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selected={toDateOrNull(addProductData?.contratoEP_dtPrev)}
                  onChange={date => date ? setAddProductData({ ...addProductData, contratoEP_dtPrev: date, contratoEP_dtPrev_Invalid: false }) : setAddProductData({ ...addProductData, contratoEP_dtPrev: null, contratoEP_dtPrev_Invalid: true })}
                />
              </FormGroup>
            </>
          )}
          <Button
            type="button"
            onClick={() => { setAddProductData({}); setOpenAddProductModal(false) }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={() => handleAddProduct()}
            disabled={
              !addProductData?.contratoProd_desc
              || !addProductData?.contratoProd_prazo
              || !addProductData?.contratoProd_dtPrev
              || (addProductData.hasPaymentEvent && (!addProductData?.contratoEP_vlr || !addProductData?.contratoEP_prazo || !addProductData?.contratoEP_dtPrev))
            }
          >
            Adicionar
          </Button>
        </Box>
      </Modal>

      <Modal
        open={openEditProductModal}
        onClose={() => setOpenEditProductModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Editar produto
          </Typography>
          <FormGroup>
            <Label>
              Descrição
            </Label>
            <Input
              value={editProductData?.contratoProd_desc}
              onChange={e => {
                setEditProductData({ ...editProductData, contratoProd_desc: e.target.value || null });
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Prazo de entrega
            </Label>
            <RadioGroup
              row
              defaultValue={true}
              name="radio-buttons-group"
              onChange={(e) => {
                setEditProductData({ ...editProductData, contratoProd_prazo: e.target.value || null })
              }} // Parse to boolean
            >
              <FormControlLabel
                control={<Radio value="30 dias" />}
                label="30 dias"
                checked={editProductData.contratoProd_prazo === '30 dias'}
              />
              <FormControlLabel
                control={<Radio value="45 dias" />}
                label="45 dias"
                checked={editProductData.contratoProd_prazo === '45 dias'}
              />
              <FormControlLabel
                control={<Radio value="60 dias" />}
                label="60 dias"
                checked={editProductData.contratoProd_prazo === '60 dias'}
              />
            </RadioGroup>
            <Input
              value={editProductData?.contratoProd_prazo}
              onChange={e => {
                setEditProductData({ ...editProductData, contratoProd_prazo: e.target.value || null });
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Data de entrega prevista
            </Label>

            <DatePicker
              placeholderText="__/__/_____"
              locale="pt-BR"
              className="form-control"
              dateFormat="dd/MM/yyyy"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={
                (!editProductData.contratoProd_id && editProductData.contratoProd_dtPrev) ?
                  (
                    editProductData.productId ?
                      toDateOrNull(editProductData.contratoProd_dtPrev) : null
                  ) :
                  editProductData.contratoProd_dtPrev ?
                    toDateOrNull(editProductData.contratoProd_dtPrev) :
                    null
              }
              onChange={date => {
                !editProductData.contratoProd_id ?
                  (editProductData.productId &&
                    setEditProductData({ ...editProductData, contratoProd_dtPrev: date, contratoProd_dtPrev_Invalid: false })
                  ) :
                  setEditProductData({ ...editProductData, contratoProd_dtPrev: date, contratoProd_dtPrev_Invalid: false })
              }}
            />
          </FormGroup>

          <Row>
            <Col>
              <hr />
            </Col>
          </Row>

          <Row className="mb-2 mt-2">
            <Col>
              <Label>
                Possui evento de pagamento
              </Label>
            </Col>

            <Col className="d-flex justify-content-end">
              <CustomInput
                type="switch"
                id="hasPaymentEvent"
                checked={editProductData.hasPaymentEvent || editProductData.contratoEP_id}
                onChange={e => {
                  if (e.target.checked) {
                    setEditProductData({ ...editProductData, hasPaymentEvent: e?.target?.checked });
                  } else {
                    if (editProductData.paymentId) {
                      setEditProductData({ contratoProd_desc: editProductData.contratoProd_desc, contratoProd_prazo: editProductData.contratoProd_prazo, contratoProd_dtPrev: editProductData.contratoProd_dtPrev, hasPaymentEvent: false });
                    } else if (editProductData.contratoEP_id) {
                      setEditProductData({ contratoProd_desc: editProductData.contratoProd_desc, contratoProd_prazo: editProductData.contratoProd_prazo, contratoProd_dtPrev: editProductData.contratoProd_dtPrev, hasPaymentEvent: false });
                    }
                  }
                }}
              />
            </Col>
          </Row>

          {(editProductData.hasPaymentEvent || editProductData.contratoEP_id) && (
            <>
              <FormGroup>
                <Label>
                  Valor
                </Label>
                <MaskedInput
                  unmask
                  mask="R$ num"
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      min: 0,
                      max: 1000000000
                      /*
                      editPaymentData.contratoProd_id ?
                       (valorGlobal - (paymentEvents.filter(pe=>pe.contratoProd_id !== editPaymentData.contratoProd_id).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))) :
                       (valorGlobal - (paymentEvents.filter(pe=>pe.tempId !== editPaymentData.tempId).reduce((ac, current)=> ac + current.contratoEP_vlr, 0)))
                      */
                    },
                  }}
                  lazy={false}
                  value={!editProductData.contratoProd_id ? editProductData.contratoEP_vlr : String(editPaymentData.contratoEP_vlr)}
                  onAccept={value => {
                    !editProductData.contratoProd_id ?
                      setEditProductData({ ...editProductData, contratoEP_vlr: value, }) :
                      setEditPaymentData({ ...editPaymentData, contratoEP_vlr: value, })
                  }}
                />
              </FormGroup>

              {/*
              <FormGroup>
                <Label>
                  Porcentagem
                </Label>
                <MaskedInput
                  unmask
                  mask="num %"
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      max: editPaymentData.contratoProd_id ?
                      (100 - (100*(paymentEvents.filter(pe=>pe.contratoProd_id !== editPaymentData.contratoProd_id).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))/valorGlobal)) :
                      (100 - (100*(paymentEvents.filter(pe=>pe.tempId !== editPaymentData.tempId).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))/valorGlobal)),
                  },
                  }}
                  lazy={false}
                  value={String(100*(editPaymentData.contratoEP_vlr)/valorGlobal)}
                  onAccept={value => {
                      if (Number(value) > 0) {
                        setEditPaymentData({...editProductData, contratoEP_vlr: valorGlobal*(Number(value)/100)});
                      }
                  }}
                />
              </FormGroup>
              */}


              <FormGroup>
                <Label>
                  Prazo de pagamento
                </Label>
                <RadioGroup
                  row
                  defaultValue={true}
                  name="radio-buttons-group"
                  onChange={(e) => {
                    !editProductData.contratoProd_id ?
                      setEditProductData({ ...editProductData, contratoEP_prazo: e.target.value || null }) :
                      setEditPaymentData({ ...editPaymentData, contratoEP_prazo: e.target.value || null })
                  }} // Parse to boolean
                >
                  <FormControlLabel
                    control={<Radio value="30 dias" />}
                    label="30 dias"
                    checked={!editProductData.contratoProd_id ? editProductData.contratoEP_prazo === '30 dias' : editPaymentData.contratoEP_prazo === '30 dias'}
                  />
                  <FormControlLabel
                    control={<Radio value="45 dias" />}
                    label="45 dias"
                    checked={!editProductData.contratoProd_id ? editProductData.contratoEP_prazo === '45 dias' : editPaymentData.contratoEP_prazo === '45 dias'}
                  />
                  <FormControlLabel
                    control={<Radio value="60 dias" />}
                    label="60 dias"
                    checked={!editProductData.contratoProd_id ? editProductData.contratoEP_prazo === '60 dias' : editPaymentData.contratoEP_prazo === '60 dias'}
                  />
                </RadioGroup>
                <Input
                  value={!editProductData.contratoProd_id ? editProductData?.contratoEP_prazo : editPaymentData.contratoEP_prazo}
                  onChange={e => {
                    !editProductData.contratoProd_id ?
                      setEditProductData({ ...editProductData, contratoEP_prazo: e.target.value || null }) :
                      setEditPaymentData({ ...editPaymentData, contratoEP_prazo: e.target.value || null })
                  }}
                />
              </FormGroup>

              <FormGroup>
                <Label>
                  Data de pagamento prevista
                </Label>

                <DatePicker
                  placeholderText="__/__/_____"
                  locale="pt-BR"
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selected={
                    !editProductData.contratoProd_id ?
                      toDateOrNull(editProductData.contratoEP_dtPrev) :
                      toDateOrNull(editPaymentData.contratoEP_dtPrev)
                  }
                  onChange={date => {
                    editProductData.contratoProd_id ?
                      setEditPaymentData({ ...editPaymentData, contratoEP_dtPrev: date, contratoEP_dtPrev_Invalid: false }) :
                      setEditProductData({ ...editProductData, contratoEP_dtPrev: date, contratoEP_dtPrev_Invalid: false });
                  }}
                />
              </FormGroup>
            </>
          )}
          <Button
            type="button"
            onClick={() => { setEditProductData({}); setOpenEditProductModal(false) }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={() => handleEditProduct()}
            disabled={
              !editProductData?.contratoProd_desc
              || !editProductData?.contratoProd_prazo
              || !editProductData?.contratoProd_dtPrev
              || (editProductData.hasPaymentEvent && (
                (editProductData.tempId && editProductData.hasPaymentEvent && (!editProductData?.contratoEP_vlr || !editProductData?.contratoEP_prazo || !editProductData?.contratoEP_dtPrev)) ||
                (editProductData.contratoProd_id && editProductData.hasPaymentEvent && (!editPaymentData?.contratoEP_vlr || !editPaymentData?.contratoEP_prazo || !editPaymentData?.contratoEP_dtPrev))
              ))
            }
          >
            Salvar
          </Button>
        </Box>
      </Modal>

      <Modal
        open={openEditPaymentModal}
        onClose={() => setOpenEditPaymentModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Editar evento de pagamento
          </Typography>
          <FormGroup>
            <Label>
              Valor
            </Label>
            <MaskedInput
              unmask
              mask="R$ num"
              blocks={{
                num: {
                  mask: Number,
                  scale: 2, // digits after point 0 for integers
                  signed: false, // disallow negative
                  thousandsSeparator: '.', // any single char
                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                  normalizeZeros: false, // appends or removes zeros at ends
                  radix: ',', // fractional delimiter
                  min: 0,
                  max: 1000000000
                  /*
                  editPaymentData.contratoProd_id ?
                    (valorGlobal - (paymentEvents.filter(pe=>pe.contratoProd_id !== editPaymentData.contratoProd_id).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))) :
                    (valorGlobal - (paymentEvents.filter(pe=>pe.tempId !== editPaymentData.tempId).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))),
                  */
                },
              }}
              lazy={false}
              value={!editPaymentData.contratoProd_id ? (editPaymentData.productId ? editProductData.contratoEP_vlr : String(editPaymentData.contratoEP_vlr)) : String(editPaymentData.contratoEP_vlr)}
              onAccept={value => {
                !editPaymentData.contratoProd_id ?
                  (editPaymentData.productId ?
                    setEditProductData({ ...editProductData, contratoEP_vlr: value, }) :
                    setEditPaymentData({ ...editPaymentData, contratoEP_vlr: value, })
                  ) :
                  setEditPaymentData({ ...editPaymentData, contratoEP_vlr: value, })
              }}
            />
          </FormGroup>

          {/*
              <FormGroup>
                <Label>
                  Porcentagem
                </Label>
                <MaskedInput
                  unmask
                  mask="num %"
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      max: editPaymentData.contratoProd_id ?
                        (100 - (100*(paymentEvents.filter(pe=>pe.contratoProd_id !== editPaymentData.contratoProd_id).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))/valorGlobal)) :
                        (100 - (100*(paymentEvents.filter(pe=>pe.tempId !== editPaymentData.tempId).reduce((ac, current)=> ac + current.contratoEP_vlr, 0))/valorGlobal)),
                    },
                  }}
                  lazy={false}
                  value={String(100*(editPaymentData.contratoEP_vlr)/valorGlobal)}
                  onAccept={value => {
                      if (Number(value) > 0) {
                        setEditPaymentData({...editPaymentData, contratoEP_vlr: valorGlobal*(Number(value)/100)});
                      }
                  }}
                />
              </FormGroup>
              */}


          <FormGroup>
            <Label>
              Prazo de pagamento
            </Label>
            <RadioGroup
              row
              defaultValue={true}
              name="radio-buttons-group"
              onChange={(e) => {
                !editPaymentData.contratoProd_id ?
                  (editPaymentData.productId ?
                    setEditProductData({ ...editProductData, contratoEP_prazo: e.target.value || null, }) :
                    setEditPaymentData({ ...editPaymentData, contratoEP_prazo: e.target.value || null, })
                  ) :
                  setEditPaymentData({ ...editPaymentData, contratoEP_prazo: e.target.value || null, })
              }} // Parse to boolean
            >
              <FormControlLabel
                control={<Radio value="30 dias" />}
                label="30 dias"
                checked={!editPaymentData.contratoProd_id ? (editPaymentData.productId ? editProductData.contratoEP_prazo === '30 dias' : editPaymentData.contratoEP_prazo === '30 dias') : editPaymentData.contratoEP_prazo === '30 dias'}
              />
              <FormControlLabel
                control={<Radio value="45 dias" />}
                label="45 dias"
                checked={!editPaymentData.contratoProd_id ? (editPaymentData.productId ? editProductData.contratoEP_prazo === '45 dias' : editPaymentData.contratoEP_prazo === '45 dias') : editPaymentData.contratoEP_prazo === '45 dias'}
              />
              <FormControlLabel
                control={<Radio value="60 dias" />}
                label="60 dias"
                checked={!editPaymentData.contratoProd_id ? (editPaymentData.productId ? editProductData.contratoEP_prazo === '60 dias' : editPaymentData.contratoEP_prazo === '60 dias') : editPaymentData.contratoEP_prazo === '60 dias'}
              />
            </RadioGroup>
            <Input
              value={!editPaymentData.contratoProd_id ? (editPaymentData.productId ? editProductData.contratoEP_prazo : editPaymentData.contratoEP_prazo) : editPaymentData.contratoEP_prazo}
              onChange={e => {
                !editPaymentData.contratoProd_id ?
                  (editPaymentData.productId ?
                    setEditProductData({ ...editProductData, contratoEP_prazo: e.target.value || null, }) :
                    setEditPaymentData({ ...editPaymentData, contratoEP_prazo: e.target.value || null, })
                  ) :
                  setEditPaymentData({ ...editPaymentData, contratoEP_prazo: e.target.value || null, })
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Data de pagamento prevista
            </Label>

            <DatePicker
              placeholderText="__/__/_____"
              locale="pt-BR"
              className="form-control"
              dateFormat="dd/MM/yyyy"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={
                (!editProductData.contratoProd_id && editProductData.contratoEP_dtPrev) ?
                  (
                    editPaymentData.productId ?
                      toDateOrNull(editProductData.contratoEP_dtPrev) : (editPaymentData.contratoEP_dtPrev) ?
                        toDateOrNull(editPaymentData.contratoEP_dtPrev) : null
                  ) :
                  editPaymentData.contratoEP_dtPrev ?
                    toDateOrNull(editPaymentData.contratoEP_dtPrev) :
                    null
              }
              onChange={date => {
                !editPaymentData.contratoProd_id ?
                  (editPaymentData.productId ?
                    setEditProductData({ ...editProductData, contratoEP_dtPrev: date, contratoEP_dtPrev_Invalid: false }) :
                    setEditPaymentData({ ...editPaymentData, contratoEP_dtPrev: date, contratoEP_dtPrev_Invalid: false })
                  ) :
                  setEditPaymentData({ ...editPaymentData, contratoEP_dtPrev: date, contratoEP_dtPrev_Invalid: false })
              }}
            />
          </FormGroup>

          <Row>
            <Col>
              <hr />
            </Col>
          </Row>

          <Button
            type="button"
            onClick={() => { setEditProductData({}); setOpenEditPaymentModal(false) }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={() => handleEditPayment()}
            disabled={
              !editPaymentData?.contratoEP_vlr
              || !editPaymentData?.contratoEP_prazo
              || !editPaymentData?.contratoEP_dtPrev
            }
          >
            Salvar
          </Button>
        </Box>
      </Modal>

      <Modal
        open={openDeleteProductModal}
        onClose={() => setOpenDeleteProductModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Deleção de produto
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            O produto não pode ser deletado pois possui pelo menos um evento de pagamento relacionado a ele.
          </Typography>
          <Button
            type="button"
            onClick={() => { setOpenDeleteProductModal(false) }}
            color="light"
            className="waves-effect"
          >
            Fechar
          </Button>
        </Box>
      </Modal>

      <ModalConfirmacao
        openModal={openModalCloseConfirmation}
        onClosed={() => setOpenModalCloseConfirmation(false)}
        title={'Fechar sem salvar?'}
        subtitle={`As informações alteradas serão perdidas.`}
        confirmButtonText='Fechar'
        onConfirm={() => { handleClose(); setOpenModalCloseConfirmation(false); }}
      />

      <Modal
        open={openAddPaymentEventModal}
        onClose={() => setOpenAddPaymentEventModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
        }}>
          <Typography id="modal-modal-title" variant="h6" component="h2"
          >
            Adicionar evento de pagamento
          </Typography>
          <FormGroup>
            <Label>
              Tipo
            </Label>

            <AsyncSelect
              cacheOptions
              defaultOptions
              isSearchable={false}
              isClearable={false}
              isMulti={false}
              getOptionValue={option => option.recTp_id}
              getOptionLabel={option => option.recTp_nome}
              value={addPaymentData.recTp_id}
              loadOptions={async () => {
                try {
                  const res = await oikosApi.get('/', {
                    action: 'get',
                    table: 'recTp',
                  })

                  if (addPaymentData.recTp_id !== undefined) {
                    setAddPaymentData({ ...addPaymentData, recTp_id: res.data.find(i => i.recTp_id === addPaymentData.recTp_id) })
                  }

                  return res.data.filter(item => item.recTp_nome !== 'Produto')
                } catch (e) {
                  return notifyError(e)
                }
              }}
              onChange={e => {
                setAddPaymentData({ ...addPaymentData, recTp_id: e })

              }}
            />
          </FormGroup>

          {
            addPaymentData.recTp_id?.recTp_id === 6 &&
            <MaterialReactTable
              columns={columns}
              data={products.filter(p => {

                const productsIdsInPaymentEvents = []

                products.forEach(p => {
                  if (p.paymentId) {
                    productsIdsInPaymentEvents.push(p.paymentId)
                  } else if (p.contratoEP_id) {
                    productsIdsInPaymentEvents.push(p.contratoEP_id)
                  }
                })

                if ((p.paymentId && !productsIdsInPaymentEvents.includes(p.paymentId))) {
                  return true
                } else if ((p.contratoEP_id && !productsIdsInPaymentEvents.includes(p.contratoEP_id))) {
                  return true
                } else if ((!p.contratoEP_id && !p.paymentId)) {
                  return true
                }
                return false
              })}
              initialState={{
                density: 'compact',
                expanded: false, //expand all groups by default
                pagination: { pageIndex: 0, pageSize: 20 },
                sorting: [{ id: 'contratoProd_desc', desc: false }], //sort by state by default
              }}
              enableGrouping={false}
              enableGlobalFilter={true}
              enableFilters={true}
              enablePagination={false}
              enableTopToolbar={false}
              enableRowActions
              renderRowActions={({ row }) => {

                return (
                  <div className='d-flex justify-content-center align-items-center'>
                    <input type="checkbox"
                      onChange={(e) => {

                        if (row.original.tempId) {
                          if (e.target.checked) {
                            const obj = products.find(p => p.tempId === row.original.tempId);
                            if (obj) {
                              setProdutosMedicaoComposta([...produtosMedicaoComposta, obj.tempId])
                              setAddPaymentData((prev) => {
                                if (prev.produtosMedicaoComposta) {
                                  return { ...prev, produtosMedicaoComposta: [...prev.produtosMedicaoComposta, obj.tempId] }
                                } else {
                                  return { ...prev, produtosMedicaoComposta: [obj.tempId] }
                                }
                              })
                            }
                          } else {
                            const obj = products.find(p => p.tempId === row.original.tempId);
                            if (obj) {
                              setProdutosMedicaoComposta(prev =>
                                prev.filter(id => id !== obj.tempId)
                              );

                              setAddPaymentData(prev => {
                                if (prev.produtosMedicaoComposta) {
                                  return {
                                    ...prev,
                                    produtosMedicaoComposta: prev.produtosMedicaoComposta.filter(id => id !== obj.tempId)
                                  };
                                }
                                return prev; // No need to change if produtosMedicaoComposta doesn't exist
                              });
                            }
                          }
                        } else if (row.original.contratoProd_id) {
                          if (e.target.checked) {
                            const obj = products.find(p => p.contratoProd_id === row.original.contratoProd_id);
                            if (obj) {
                              setProdutosMedicaoComposta([...produtosMedicaoComposta, obj.contratoProd_id])
                              setAddPaymentData((prev) => {
                                if (prev.produtosMedicaoComposta) {
                                  return { ...prev, produtosMedicaoComposta: [...prev.produtosMedicaoComposta, obj.contratoProd_id] }
                                } else {
                                  return { ...prev, produtosMedicaoComposta: [obj.contratoProd_id] }
                                }
                              })
                            }
                          } else {
                            const obj = products.find(p => p.contratoProd_id === row.original.contratoProd_id);
                            if (obj) {
                              setProdutosMedicaoComposta(prev =>
                                prev.filter(id => id !== obj.contratoProd_id)
                              );

                              setAddPaymentData(prev => {
                                if (prev.produtosMedicaoComposta) {
                                  return {
                                    ...prev,
                                    produtosMedicaoComposta: prev.produtosMedicaoComposta.filter(id => id !== obj.contratoProd_id)
                                  };
                                }
                                return prev; // No need to change if produtosMedicaoComposta doesn't exist
                              });
                            }
                          }
                        }
                      }}
                    />
                  </div>
                )
              }}

            />
          }

          <FormGroup className={addPaymentData.recTp_id?.recTp_id === 6 ? 'mt-4' : ''}>
            <Label>
              Descrição
            </Label>
            <Input
              value={addPaymentData?.contratoEP_desc}
              onChange={e => setAddPaymentData({
                ...addPaymentData,
                contratoEP_desc: e.target.value || null,
              })}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Valor
            </Label>
            <MaskedInput
              unmask
              mask="R$ num"
              disabled={valorGlobal - (paymentEvents.reduce((ac, current) => ac + current.contratoEP_vlr, 0)) === 0}
              blocks={{
                num: {
                  mask: Number,
                  scale: 2, // digits after point 0 for integers
                  signed: false, // disallow negative
                  thousandsSeparator: '.', // any single char
                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                  normalizeZeros: false, // appends or removes zeros at ends
                  radix: ',', // fractional delimiter
                  min: 0,
                  max: 1000000000//(valorGlobal - paymentEvents.reduce((ac, current)=> ac + Number(current.contratoEP_vlr), 0)),
                },
              }}
              lazy={false}
              value={String(addPaymentData.contratoEP_vlr)}
              onAccept={value => {
                setAddPaymentData({ ...addPaymentData, contratoEP_vlr: value });
              }}
            />
          </FormGroup>

          {/*
          <FormGroup>
            <Label>
              Porcentagem
            </Label>
            <MaskedInput
              unmask
              mask="num %"
              blocks={{
                num: {
                  mask: Number,
                  scale: 2, // digits after point 0 for integers
                  signed: false, // disallow negative
                  thousandsSeparator: '.', // any single char
                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                  normalizeZeros: false, // appends or removes zeros at ends
                  radix: ',', // fractional delimiter
                  max: (100 - (100*(paymentEvents.reduce((ac, current)=> ac + Number(current.contratoEP_vlr), 0))/valorGlobal)),
                },
              }}
              lazy={false}
              value={String(100*(addPaymentData.contratoEP_vlr)/valorGlobal)}
              onAccept={value => {
                  if (Number(value) > 0) {
                    setAddPaymentData({...addPaymentData, contratoEP_vlr: valorGlobal*(Number(value)/100)});
                  }
              }}
            />
          </FormGroup>
          */}


          <FormGroup>
            <Label>
              Prazo de pagamento
            </Label>
            <Input
              value={addPaymentData?.contratoEP_prazo}
              onChange={e => {
                setAddPaymentData({ ...addPaymentData, contratoEP_prazo: e.target.value || null })
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label>
              Data de pagamento prevista
            </Label>

            <DatePicker
              placeholderText="__/__/_____"
              locale="pt-BR"
              className="form-control"
              dateFormat="dd/MM/yyyy"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={toDateOrNull(addPaymentData?.contratoEP_dtPrev)}
              onChange={date => {
                setAddPaymentData({
                  ...addPaymentData,
                  contratoEP_dtPrev: date,
                  contratoEP_dtPrev_Invalid: false,
                })
              }}
            />
          </FormGroup>
          <Button
            type="button"
            onClick={() => {
              setAddPaymentData({});
              setOpenAddPaymentEventModal(false);
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={() => handleAddPayment()}
            disabled={
              !addPaymentData?.contratoEP_desc
              || !addPaymentData?.recTp_id
              || !addPaymentData?.contratoEP_prazo
              || !addPaymentData?.contratoEP_vlr
              || !addPaymentData?.contratoEP_dtPrev
              || (addPaymentData?.recTp_id?.recTp_nome === 'Produto' && !addPaymentData?.product)
            }
          >
            Adicionar
          </Button>
        </Box>
      </Modal>
      {/*
      */}
      {deletePaymentData && ((deletePaymentData.contratoProd_id) ?
        <ModalConfirmacao
          openModal={openModalConfirmEPDelete}
          onClosed={() => setOpenModalConfirmEPDelete(false)}
          title={'Confirma deleção?'}
          subtitle={`Essa ação também apagará o produto referente a esse evento de pagamento (${deletePaymentData.contratoEP_desc}). Deseja deletar mesmo assim?`}
          onConfirm={() => handleDeletePayment(deletePaymentData.index)}
        /> : (deletePaymentData.productId) ?
          <ModalConfirmacao
            openModal={openModalConfirmEPDelete}
            onClosed={() => setOpenModalConfirmEPDelete(false)}
            title={'Confirma deleção?'}
            subtitle={`Essa ação também apagará o produto referente a esse evento de pagamento (${deletePaymentData.contratoEP_desc}). Deseja deletar mesmo assim?`}
            onConfirm={() => handleDeletePayment(deletePaymentData.index)}
          /> :
          <ModalConfirmacao
            openModal={openModalConfirmEPDelete}
            onClosed={() => setOpenModalConfirmEPDelete(false)}
            title={'Confirma deleção?'}
            subtitle={`Deseja deletar o evento ${deletePaymentData.contratoEP_desc}?`}
            onConfirm={() => handleDeletePayment(deletePaymentData.index)}
          />
      )
      }
          </>
        );
      })()}
    </>
  );
}

export default AddContract2;
